export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "de-DE",
    "Messages": {
        ".": ".",
        "...": "...",
        "2 dni": "2 Tage",
        "2 miesiące": "2 Monate",
        "2 tygodnie": "2 Wochen",
        "3 dni": "3 Tage",
        "3 miesiące": "3 Monate",
        "4 dni": "4 Tage",
        "5 dni": "5 Tage",
        "6 dni": "6 Tage",
        "Aby skonfigurować wysyłkę, należy uzułenić wymagane pola.": "Um den Versand zu konfigurieren, müssen die erforderlichen Felder ausgefüllt werden.",
        "Adres": "Adresse",
        "Adres email": "E-Mail-Adresse",
        "Adres email jest pusty.": "Die E-Mail-Adresse ist leer.",
        "Adres email odbiorcy": "E-Mail-Adresse des Empfängers",
        "Adres endpointu": "Endpoint-Adresse",
        "Adres URL": "URL-Adresse",
        "Adres URL został skopiowany.": "Die URL-Adresse wurde kopiert.",
        "Adres został skopiowany do schowka.": "Die Adresse wurde in die Zwischenablage kopiert.",
        "AI": "AI",
        "Akcent": "Akzent",
        "Akceptacja": "Freigabe",
        "Akceptacja dokumentów": "Dokumentenfreigabe",
        "Akceptacja dokumentu": "Dokumentenfreigabe",
        "Akceptacja własnych dokumentów": "Freigabe eigener Dokumente",
        "Akceptacja wszystkich dokumentów": "Freigabe aller Dokumente",
        "Akceptowalny typ plików": "Zulässiger Dateityp",
        "Akceptowany format danych": "Zulässiges Datenformat",
        "Akceptuj": "Akzeptieren",
        "Akcje": "Aktionen",
        "Akordeon": "Akkordeon",
        "Aktualizacja definicji": "Definitionsaktualisierung",
        "Aktualizacja dokumentu": "Dokumentenaktualisierung",
        "Aktualizacja encji": "Entitätsaktualisierung",
        "Aktualizacja wpisu": "Eintragsaktualisierung",
        "Aktualizowane pola": "Aktualisierte Felder",
        "Aktualizuj": "Aktualisieren",
        "Aktywne": "Aktiv",
        "Aktywność i widoczność w menu panelu.": "Aktivität und Sichtbarkeit im Menü des Panels.",
        "Aktywny": "Aktiv",
        "Aktywny webhook": "Aktiver Webhook",
        "AND — użytkownik musi mieć wszystkie zaznaczone uprawnienia. OR — wystarczy dowolne z nich. Zaznacz uprawnienia poniżej i wybierz sposób ich łączenia.": "AND – der Benutzer muss über alle ausgewählten Berechtigungen verfügen. OR – eine beliebige davon genügt. Wählen Sie unten die Berechtigungen aus und legen Sie fest, wie sie verknüpft werden sollen.",
        "Ankieta": "Umfrage",
        "Anonimizacja": "Anonymisierung",
        "Anonimowy": "Anonym",
        "Anulowany": "Abgebrochen",
        "Anuluj": "Abbrechen",
        "Any sprawdza, czy istnieje pasujący rekord; Count zwraca ich liczbę; FirstOrDefault zwraca pierwszy rekord; ToList zwraca wszystkie rekordy; Sum, Min, Max i Average obliczają wartość dla wskazanego pola.": "Any prüft, ob ein passender Datensatz vorhanden ist; Count gibt die Anzahl zurück; FirstOrDefault gibt den ersten Datensatz zurück; ToList gibt alle Datensätze zurück; Sum, Min, Max und Average berechnen den Wert für das angegebene Feld.",
        "Aplikacja": "Anwendung",
        "Aranżacje: %0": "Layouts: %0",
        "Audio": "Audio",
        "Automatyzacja": "Automatisierung",
        "Autouzupełnianie": "Automatische Vervollständigung",
        "Baza danych": "Datenbank",
        "Bazowy model danych": "Basismodell der Daten",
        "Bezpieczeństwo": "Sicherheit",
        "Biblioteka skryptów": "Skriptbibliothek",
        "Bieżący dokument": "Aktuelles Dokument",
        "Błąd": "Fehler",
        "Błędne": "Fehlerhaft",
        "Błędny": "Fehlerhaft",
        "Bloczek przetwarza wejście collection. Ścieżka JSON wskazuje pole elementu, np. customer.email. Znak $ oznacza cały element kolekcji.": "Der Block verarbeitet die Eingabe collection. Der JSON-Pfad gibt das Feld des Elements an, z. B. customer.email. Das Zeichen $ steht für das gesamte Element der Sammlung.",
        "Bool": "Bool",
        "brak": "keine",
        "Brak": "Keine",
        "Brak danych": "Keine Daten",
        "Brak definicji formularza.": "Keine Formulardefinition.",
        "Brak dodanych kolumn": "Keine Spalten hinzugefügt",
        "Brak drugiej wersji do porównania": "Keine zweite Version zum Vergleichen",
        "Brak komponentu": "Keine Komponente",
        "Brak odpowiedzi": "Keine Antwort",
        "Brak opublikowanej definicji formularza": "Keine veröffentlichte Formulardefinition",
        "Brak pasujących elementów.": "Keine passenden Elemente.",
        "Brak pasujących kontrolek wśród wczytanych.": "Keine passenden Steuerelemente unter den geladenen.",
        "Brak różnic między wybranymi wersjami": "Keine Unterschiede zwischen den ausgewählten Versionen",
        "Brak sekcji": "Keine Sektion",
        "Brak właściwości do konfiguracji.": "Keine Eigenschaften zum Konfigurieren.",
        "Brak wyboru": "Keine Auswahl",
        "brak wyboru...": "Keine Auswahl...",
        "Brak wykonanych operacji.": "Keine Vorgänge ausgeführt.",
        "Brak załączników.": "Keine Anhänge.",
        "Build": "Build",
        "Cache": "Cache",
        "Cache będzie przechowywany z wykorzystaniem serwera Redis.": "Der Cache wird auf einem Redis-Server gespeichert.",
        "Cache po stronie serwera": "Serverseitiger Cache",
        "Cache-Control": "Cache-Control",
        "Cechy": "Merkmale",
        "Checkbox": "Kontrollkästchen",
        "Ciemny": "Dunkel",
        "Cyfry": "Ziffern",
        "Czas pomiędzy": "Zeit zwischen",
        "Czas rozpoczęcia": "Startzeit",
        "Czas trwania": "Dauer",
        "Czas zakończenia": "Endzeit",
        "Cztery kolumny": "Vier Spalten",
        "Czy na pewno usunąć kontrolkę?": "Möchten Sie das Steuerelement wirklich löschen?",
        "Czy na pewno usunąć opcję?": "Möchten Sie die Option wirklich löschen?",
        "Czy na pewno usunąć pytanie?": "Möchten Sie die Frage wirklich löschen?",
        "Czy na pewno usunąć stronę formularza?": "Möchten Sie die Formularseite wirklich löschen?",
        "Czy na pewno usunąć ten warunek?": "Möchten Sie diese Bedingung wirklich löschen?",
        "Dalej": "Weiter",
        "Dane": "Daten",
        "Dane formularza są przechowywane w obiekcie Entry.": "Die Formulardaten werden im Entry-Objekt gespeichert.",
        "Dane modułu": "Moduldaten",
        "Dane odbiorcy": "Empfängerdaten",
        "Dane osobowe": "Personenbezogene Daten",
        "Dane podglądu": "Vorschaudaten",
        "Dane skopiowane do schowka.": "Daten in die Zwischenablage kopiert.",
        "Dane tabelaryczne": "Tabellarische Daten",
        "Dane techniczne": "Technische Daten",
        "Dane webhooka": "Webhook-Daten",
        "Dane wejściowe": "Eingabedaten",
        "Dane z formularza zapisywane anonimowo": "Formulardaten werden anonym gespeichert",
        "Dane źródła": "Quelldaten",
        "Data": "Datum",
        "Data dodania": "Hinzufügedatum",
        "Data i czas": "Datum und Uhrzeit",
        "Data kalendarza": "Kalenderdatum",
        "Data rozpoczęcia": "Startdatum",
        "Data rozpoczęcia publikacji": "Veröffentlichungsstartdatum",
        "Data wywołania": "Aufrufdatum",
        "Data zakończenia": "Enddatum",
        "Data zakończenia publikacji": "Veröffentlichungsenddatum",
        "Data: %0 | Autor: %1 | Status: %2": "Datum: %0 | Autor: %1 | Status: %2",
        "Data: %0 | Status: %1": "Datum: %0 | Status: %1",
        "DateTime": "DateTime",
        "Dedykowane": "Dediziert",
        "Definicja": "Definition",
        "Definicja (JSON)": "Definition (JSON)",
        "Definicja formularza znajduje się w obiekcie Form.": "Die Formulardefinition befindet sich im Form-Objekt.",
        "Definicja pól dokumentów tej sekcji.": "Definition der Dokumentfelder in diesem Abschnitt.",
        "Definicja skopiowana do schowka.": "Definition in die Zwischenablage kopiert.",
        "Definicje": "Definitionen",
        "Definicje zostały zaktualizowane.": "Die Definitionen wurden aktualisiert.",
        "DELETE: Usunięcie wpisu": "DELETE: Eintrag löschen",
        "Design Studio": "Design Studio",
        "Diagram": "Diagramm",
        "Diagram jest nieprawidłowy, nie zawiera żadnego wyzwalacza.": "Das Diagramm ist ungültig und enthält keinen Auslöser.",
        "Diagram jest nieprawidłowy, zawiera więcej niż jeden wyzwalacz.": "Das Diagramm ist ungültig und enthält mehr als einen Auslöser.",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" jest elementem dwóch różnych pętli.": "Das Diagramm ist ungültig. Die Aktion \"%0 (%1)\" ist Teil von zwei verschiedenen Schleifen.",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" nie posiada rodzica.": "Das Diagramm ist ungültig. Die Aktion \"%0 (%1)\" hat kein übergeordnetes Element.",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" nie została poprawnie skonfigurowana.": "Das Diagramm ist ungültig. Die Aktion \"%0 (%1)\" wurde nicht korrekt konfiguriert.",
        "Diagram jest nieprawidłowy. Jedna ze ścieżek zawiera niezgodną liczbę początków i zakończeń pętli.": "Das Diagramm ist ungültig. Einer der Pfade enthält eine unterschiedliche Anzahl von Schleifenanfängen und -enden.",
        "Diagram jest nieprawidłowy. Jedna ze ścieżek zawiera zagnieżdżone pętle.": "Das Diagramm ist ungültig. Einer der Pfade enthält verschachtelte Schleifen.",
        "Diagram scenariusza": "Szenariodiagramm",
        "dla wybranego modelu danych.": "für das ausgewählte Datenmodell.",
        "dla wybranego modułu dynamicznego.": "für das ausgewählte dynamische Modul.",
        "Długość": "Länge",
        "Długość czasu przechowywania": "Aufbewahrungsdauer",
        "Długość geograficzna": "Längengrad",
        "do": "bis",
        "Do": "Bis",
        "do %0": "bis %0",
        "Do akceptacji": "Zur Freigabe",
        "Dodaj": "Hinzufügen",
        "Dodaj dni": "Tage hinzufügen",
        "Dodaj dokument": "Dokument hinzufügen",
        "Dodaj element": "Element hinzufügen",
        "Dodaj endpoint": "Endpunkt hinzufügen",
        "Dodaj formularz": "Formular hinzufügen",
        "Dodaj grupę": "Gruppe hinzufügen",
        "Dodaj kategorię": "Kategorie hinzufügen",
        "Dodaj kolumnę": "Spalte hinzufügen",
        "Dodaj komponent": "Komponente hinzufügen",
        "Dodaj moduł": "Modul hinzufügen",
        "Dodaj nową wersję dokumentu": "Neue Dokumentversion hinzufügen",
        "Dodaj obraz": "Bild hinzufügen",
        "Dodaj opcję": "Option hinzufügen",
        "Dodaj parametr": "Parameter hinzufügen",
        "Dodaj podsumowanie": "Zusammenfassung hinzufügen",
        "Dodaj pole": "Feld hinzufügen",
        "Dodaj pozycję": "Position hinzufügen",
        "Dodaj punkt": "Punkt hinzufügen",
        "Dodaj pytanie": "Frage hinzufügen",
        "Dodaj scenariusz": "Szenario hinzufügen",
        "Dodaj sekcję": "Abschnitt hinzufügen",
        "Dodaj sekcję, aby skonfigurować jej formularz i właściwości.": "Fügen Sie einen Abschnitt hinzu, um dessen Formular und Eigenschaften zu konfigurieren.",
        "Dodaj stronę": "Seite hinzufügen",
        "Dodaj warunek": "Bedingung hinzufügen",
        "Dodaj webhook": "Webhook hinzufügen",
        "Dodaj webhooka": "Webhook hinzufügen",
        "Dodaj wiersz": "Zeile hinzufügen",
        "Dodaj wpis": "Eintrag hinzufügen",
        "Dodaj wydarzenie": "Ereignis hinzufügen",
        "Dodaj wyrażenie": "Ausdruck hinzufügen",
        "Dodaj źródło": "Quelle hinzufügen",
        "Dodaj źródło danych": "Datenquelle hinzufügen",
        "Dodaj...": "Hinzufügen...",
        "Dodane": "Hinzugefügt",
        "Dodane przez": "Hinzugefügt von",
        "Dodanie endpointu": "Endpunkt hinzufügen",
        "Dodanie komponentu": "Komponente hinzufügen",
        "Dodanie modułu": "Modul hinzufügen",
        "Dodanie webhooka": "Webhook hinzufügen",
        "Dodanie źródła danych": "Datenquelle hinzufügen",
        "Dodano za dużo plików (maksymalnie %0).": "Zu viele Dateien hinzugefügt (maximal %0).",
        "Dodatkowe pola do wyszukiwarki": "Zusätzliche Suchfelder",
        "Dodatkowe pola kont użytkowników": "Zusätzliche Benutzerkontofelder",
        "Dodawanie": "Hinzufügen",
        "Dodawanie dokumentów": "Dokumente hinzufügen",
        "Dodawanie i edycja własnych dokumentów": "Hinzufügen und Bearbeiten eigener Dokumente",
        "Dodawanie wartości dwóch kolumn": "Werte aus zwei Spalten addieren",
        "Dokument": "Dokument",
        "Dokument został usunięty.": "Das Dokument wurde gelöscht.",
        "Dokument został zduplikowany.": "Das Dokument wurde dupliziert.",
        "Dokumenty": "Dokumente",
        "Dołączanie plików": "Dateien anhängen",
        "Domyślna wartość": "Standardwert",
        "Domyślnie ukryte": "Standardmäßig ausgeblendet",
        "Domyślnie widoczne": "Standardmäßig sichtbar",
        "Domyślny": "Standard",
        "Dopasuj widok": "Ansicht anpassen",
        "Dopuść brak odpowiedzi": "Keine Antwort zulassen",
        "Dopuszczalne typy": "Zulässige Typen",
        "Dostęp do modułu": "Zugriff auf das Modul",
        "Dostępna jako widget": "Als Widget verfügbar",
        "Dostępne endpointy REST API": "Verfügbare REST-API-Endpunkte",
        "Dostępne są właściwości obiektów, bez ich metod.": "Die Eigenschaften von Objekten sind verfügbar, nicht jedoch deren Methoden.",
        "Dostępne zmienne": "Verfügbare Variablen",
        "Dostępność modułu": "Verfügbarkeit des Moduls",
        "Dostosuj funkcjonalności i sposób wyświetlania danych w sekcji.": "Passen Sie die Funktionen und die Darstellung der Daten im Abschnitt an.",
        "Double": "Double",
        "Dowolny": "Beliebig",
        "Dowolny wynik (Any)": "Beliebiges Ergebnis (Any)",
        "Dozwolone rozszerzenia": "Zulässige Erweiterungen",
        "Dozwolone rozszerzenia plików": "Zulässige Dateierweiterungen",
        "Dozwolone są operację dodawania (+), usuwania (-), mnożenia (*), dzielenia (/),\r\n                                potęgowania (^2), pierwiastkowania (sqrt()). Jeżeli chcemy wyliczyć dane na podstawie\r\n                                innej kolumny musimy znać jej nazwę (zwykle jest to Numeric z liczbą na końcu np.\r\n                                Numeric2, możemy to sprawdzić klikając na daną kolumnę i odczytując nazwę z nagłówka\r\n                                zakładki konfiguracyjnej pola) oraz typ kolumny musi być ustawiony na liczbowy.": "Die folgenden Operationen sind zulässig: Addition (+), Subtraktion (-), Multiplikation (*), Division (/),\r\n                                Potenzierung (^2) und Wurzelziehen (sqrt()). Wenn Sie Daten auf Grundlage einer\r\n                                anderen Spalte berechnen möchten, müssen Sie deren Namen kennen (in der Regel ist es Numeric mit einer Zahl am Ende, z. B.\r\n                                Numeric2. Sie können den Namen überprüfen, indem Sie auf die betreffende Spalte klicken und den Namen in der Kopfzeile des\r\n                                Konfigurations-Tabs des Feldes ablesen). Außerdem muss der Spaltentyp auf numerisch eingestellt sein.",
        "Dozwolone są tylko małe i duże litery": "Nur Klein- und Großbuchstaben sind zulässig",
        "Dozwolone są tylko małe litery i znak -": "Nur Kleinbuchstaben und das Zeichen - sind zulässig",
        "Drugie imię": "Zweiter Vorname",
        "Duplikuj": "Duplizieren",
        "Duplikuj dokument": "Dokument duplizieren",
        "Duplikuj punkt": "Punkt duplizieren",
        "Duplikuj wydarzenie": "Ereignis duplizieren",
        "Duże litery": "Großbuchstaben",
        "Duży": "Groß",
        "Duży układ siatki": "Großes Rasterlayout",
        "Dwie kolumny": "Zwei Spalten",
        "Dyrektywa max-age=N wskazuje, że odpowiedź pozostaje świeża do N sekund po wygenerowaniu odpowiedzi.": "Die Direktive max-age=N gibt an, dass die Antwort bis zu N Sekunden nach ihrer Erstellung aktuell bleibt.",
        "Dyrektywa no-store wskazuje, że jakikolwiek cache dowolnego rodzaju nie powinien przechowywać tej odpowiedzi.": "Die Direktive no-store gibt an, dass kein Cache – unabhängig von seiner Art – diese Antwort speichern soll.",
        "Dyrektywa PRIVATE wskazuje, że odpowiedź może być przechowywana wyłącznie w prywatnej pamięci podręcznej (np. lokalnej pamięci przeglądarki).": "Die Direktive PRIVATE gibt an, dass die Antwort ausschließlich in einem privaten Cache (z. B. im lokalen Browser-Cache) gespeichert werden darf.",
        "Dyrektywa przechowywania": "Speicherrichtlinie",
        "Dyrektywa PUBLIC wskazuje, że odpowiedź może być przechowywana we współdzielonej pamięci podręcznej (np. proxy).": "Die Direktive PUBLIC gibt an, dass die Antwort in einem gemeinsam genutzten Cache (z. B. einem Proxy) gespeichert werden darf.",
        "Dyrektywa s-maxage jest ignorowana przez prywatne pamięci podręczne i zastępuje wartość określoną przez dyrektywę max-age dla współdzielonych pamięci podręcznych.": "Die Direktive s-maxage wird von privaten Caches ignoriert und ersetzt den durch die Direktive max-age festgelegten Wert für gemeinsam genutzte Caches.",
        "Dyrektywa s-maxage wskazuje, jak długo odpowiedź pozostaje aktualna we współdzielonej pamięci podręcznej (np. proxy).": "Die Direktive s-maxage gibt an, wie lange die Antwort in einem gemeinsam genutzten Cache (z. B. einem Proxy) aktuell bleibt.",
        "Dyrektywy zakresu": "Bereichsdirektiven",
        "Dzielenie": "Division",
        "Dzielenie na paczki": "Aufteilen in Pakete",
        "dzień": "Tag",
        "Dzień": "Tag",
        "Dzisiaj": "Heute",
        "Edycja definicji": "Definition bearbeiten",
        "Edycja dokumentów": "Dokumente bearbeiten",
        "Edycja dokumentu": "Dokument bearbeiten",
        "Edycja endpointu": "Endpunkt bearbeiten",
        "Edycja komponentu": "Komponente bearbeiten",
        "Edycja modułu": "Modul bearbeiten",
        "Edycja scenariusza": "Szenario bearbeiten",
        "Edycja w dialogu": "Im Dialog bearbeiten",
        "Edycja webhooka": "Webhook bearbeiten",
        "Edycja wszystkich dokumentów": "Alle Dokumente bearbeiten",
        "Edycja źródła danych": "Datenquelle bearbeiten",
        "Edytor": "Editor",
        "Edytor lokalizowany": "Lokalisierter Editor",
        "Edytowany webhook został zmieniony.": "Der bearbeitete Webhook wurde geändert.",
        "Edytuj": "Bearbeiten",
        "Edytuj dokument": "Dokument bearbeiten",
        "Edytuj nazwę kontrolki": "Bezeichnung des Steuerelements bearbeiten",
        "Edytuj punkt": "Punkt bearbeiten",
        "Edytuj wiersz": "Zeile bearbeiten",
        "Edytuj wpis": "Eintrag bearbeiten",
        "Edytuj wydarzenie": "Ereignis bearbeiten",
        "Edytuj wyrażenie": "Ausdruck bearbeiten",
        "Eksport do Excela": "Nach Excel exportieren",
        "Eksport dokumentów": "Dokumente exportieren",
        "Eksportuj": "Exportieren",
        "Element nadrzędny": "Übergeordnetes Element",
        "Element został usunięty": "Das Element wurde gelöscht",
        "Email": "E-Mail",
        "Endpoint został dodany.": "Der Endpunkt wurde hinzugefügt.",
        "Endpoint został usunięty.": "Der Endpunkt wurde gelöscht.",
        "Endpoint został zaktualizowany.": "Der Endpunkt wurde aktualisiert.",
        "Endpointy zostały usunięte.": "Die Endpunkte wurden gelöscht.",
        "Etap": "Phase",
        "Etykieta": "Bezeichnung",
        "Etykiety": "Bezeichnungen",
        "False": "False",
        "Filmy": "Filme",
        "Filtrowanie": "Filterung",
        "Filtrowanie listy dokumentów": "Dokumentenliste filtern",
        "Filtry": "Filter",
        "Format danych": "Datenformat",
        "Formuła jest nieprawidłowa": "Die Formel ist ungültig",
        "Formularz": "Formular",
        "Formularz bazuje na nieaktualnej wersji definicji.": "Das Formular basiert auf einer veralteten Definitionsversion.",
        "Formularz jest wymagany": "Das Formular ist erforderlich",
        "Formularz nie jest gotowy do zapisu.": "Das Formular kann nicht gespeichert werden.",
        "Formularz przypisany do tej sekcji nie ma dostępnej opublikowanej definicji. Sprawdź konfigurację sekcji i publikację formularza w Design Studio.": "Für das diesem Abschnitt zugewiesene Formular ist keine veröffentlichte Definition verfügbar. Überprüfen Sie die Abschnittskonfiguration und die Veröffentlichung des Formulars in Design Studio.",
        "Formularz został dodany.": "Das Formular wurde hinzugefügt.",
        "Formularz został skopiowany.": "Das Formular wurde kopiert.",
        "Formularz został usunięty.": "Das Formular wurde gelöscht.",
        "Formularz został utworzony.": "Das Formular wurde erstellt.",
        "Formularz został wygenerowany, ale nie można go zastosować": "Das Formular wurde generiert, kann aber nicht angewendet werden",
        "Formularz został zaakceptowany.": "Das Formular wurde freigegeben.",
        "Formularz został zaktualizowany.": "Das Formular wurde aktualisiert.",
        "Formularze": "Formulare",
        "Fragment adresu URL prowadzący do sekcji.": "URL-Fragment, das zum Abschnitt führt.",
        "Funkcjonalności": "Funktionen",
        "Generowanie formularza zakończone.": "Formulargenerierung abgeschlossen.",
        "Generuj": "Generieren",
        "Generuj formularz": "Formular generieren",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "GET: Liste der Einträge (Sortierung und Seitennummerierung)",
        "GET: Pobranie danych": "GET: Daten abrufen",
        "GET: Pobranie wpisu": "GET: Eintrag abrufen",
        "GET: Schemat (definicja formularza)": "GET: Schema (Formulardefinition)",
        "Godzina": "Uhrzeit",
        "Godzina maksymalna musi mieć format HH:mm lub HH:mm:ss.": "Die maximale Uhrzeit muss das Format HH:mm oder HH:mm:ss haben.",
        "Godzina maksymalna nie może być wcześniejsza niż minimalna.": "Die maximale Uhrzeit darf nicht vor der minimalen liegen.",
        "Godzina minimalna musi mieć format HH:mm lub HH:mm:ss.": "Die minimale Uhrzeit muss das Format HH:mm oder HH:mm:ss haben.",
        "Godzina musi mieć format HH:mm lub HH:mm:ss.": "Die Uhrzeit muss das Format HH:mm oder HH:mm:ss haben.",
        "Godzina musi odpowiadać krokowi minut: %0.": "Die Uhrzeit muss dem Minutenintervall entsprechen: %0.",
        "Grafika wektorowa": "Vektorgrafik",
        "Grupa %0": "Gruppe %0",
        "Grupa uprawnień %0": "Berechtigungsgruppe %0",
        "Grupa, w której szukamy formularzy.": "Gruppe, in der nach Formularen gesucht wird.",
        "Grupowanie": "Gruppierung",
        "Harmonogram": "Zeitplan",
        "Hasło": "Passwort",
        "Hierarchia": "Hierarchie",
        "Hierarchiczny": "Hierarchisch",
        "Historia": "Verlauf",
        "i zwróć obiekt": "und ein Objekt zurückgeben",
        "Id": "ID",
        "Id dokumentu": "Dokument-ID",
        "Id encji": "Entitäts-ID",
        "ID operacji": "Vorgangs-ID",
        "ID procesu": "Prozess-ID",
        "Id wpisu": "Eintrags-ID",
        "Identyfikator używany w adresach.": "In URLs verwendete Kennung.",
        "Ignoruj wersjonowanie": "Versionierung ignorieren",
        "Ikona": "Symbol",
        "Ikona jest wymagana": "Das Symbol ist erforderlich",
        "Ikona modułu": "Modulsymbol",
        "Ikona widgetu": "Widget-Symbol",
        "Ikona widoczna obok nazwy komponentu w przyborniku.": "Symbol, das neben dem Komponentennamen in der Toolbox angezeigt wird.",
        "Ilość elementów: %0": "Anzahl der Elemente: %0",
        "Ilość powtórzeń pętli": "Anzahl der Schleifenwiederholungen",
        "Ilość powtórzeń po wystąpieniu błędu": "Anzahl der Wiederholungen nach einem Fehler",
        "Ilość wierszy": "Anzahl der Zeilen",
        "Ilość wyników do odrzucenia": "Anzahl der zu überspringenden Ergebnisse",
        "Ilość wyników do pobrania": "Anzahl der abzurufenden Ergebnisse",
        "Ilość znaków": "Anzahl der Zeichen",
        "Ilość znaków odpowiedzi": "Anzahl der Antwortzeichen",
        "Imię": "Vorname",
        "Import": "Import",
        "Import CSV": "CSV-Import",
        "Import dokumentów został rozpoczęty.": "Der Dokumentimport wurde gestartet.",
        "Import modułu": "Modulimport",
        "Importuj": "Importieren",
        "Importuj definicję formularza": "Formulardefinition importieren",
        "Importuj definicję scenariusza": "Szenariodefinition importieren",
        "Indeksowanie": "Indizierung",
        "Info": "Info",
        "Informacja": "Information",
        "Informacje o generatorze": "Informationen zum Generator",
        "input1 < input2": "input1 < input2",
        "Instrukcje": "Anleitungen",
        "Int": "Int",
        "Jak napisać walidację": "So schreiben Sie eine Validierung",
        "Jak zbudować zapytanie": "So erstellen Sie eine Abfrage",
        "Jakość obrazu": "Bildqualität",
        "Jasny": "Hell",
        "Jedna kolumna": "Eine Spalte",
        "Jedno uprawnienie do dostępu obejmuje wszystkie operacje w sekcji.": "Eine Zugriffsberechtigung umfasst alle Vorgänge im Abschnitt.",
        "Jeśli użyłeś zmiennych, test się nie powiedzie. Wykonaj test bez użycia zmiennych. Wyniki testu zawszę będą ograniczone do maksymalnie 10 pozycji.": "Wenn Sie Variablen verwendet haben, schlägt der Test fehl. Führen Sie den Test ohne Variablen aus. Die Testergebnisse sind immer auf maximal 10 Einträge begrenzt.",
        "Język jest wymagany.": "Die Sprache ist erforderlich.",
        "JSON": "JSON",
        "Kafelki": "Kacheln",
        "Kalendarz": "Kalender",
        "Kanał jest wymagany": "Der Kanal ist erforderlich",
        "Kategoria": "Kategorie",
        "Kategoria formularzy modułu.": "Kategorie der Modulformulare.",
        "Kategoria jest wymagana": "Die Kategorie ist erforderlich",
        "Kategoria została dodana.": "Die Kategorie wurde hinzugefügt.",
        "Kategoria została usunięta.": "Die Kategorie wurde gelöscht.",
        "Kategoria została zaktualizowana.": "Die Kategorie wurde aktualisiert.",
        "Kategorie": "Kategorien",
        "Każdy skrypt ma inną listę parametrów wejściowych.": "Jedes Skript hat eine andere Liste von Eingabeparametern.",
        "Kierunek sortowania": "Sortierrichtung",
        "Klucz": "Schlüssel",
        "Kod i walidacja": "Code und Validierung",
        "Kod pocztowy": "Postleitzahl",
        "Kod walidacji": "Validierungscode",
        "Kod źródłowy": "Quellcode",
        "Kolejność i konfiguracja sekcji modułu.": "Reihenfolge und Konfiguration der Modulabschnitte.",
        "Kolejność sekcji": "Reihenfolge der Abschnitte",
        "Kolor": "Farbe",
        "Kolor ikony": "Symbolfarbe",
        "Kolumna": "Spalte",
        "Kolumny": "Spalten",
        "Komponent formularza": "Formularkomponente",
        "Komponent którego wartość zostanie użyta jako nazwa elementu nadrzędnego. Dostępne tylko komponenty typu ``Tekst``.": "Komponente, deren Wert als Name des übergeordneten Elements verwendet wird. Nur Komponenten vom Typ ``Text`` sind verfügbar.",
        "Komponent relacyjny": "Relationale Komponente",
        "Komponent został dodany.": "Die Komponente wurde hinzugefügt.",
        "Komponent został usunięty.": "Die Komponente wurde gelöscht.",
        "Komponent został zaktualizowany.": "Die Komponente wurde aktualisiert.",
        "Komponent źródłowy": "Quellkomponente",
        "Komponenty": "Komponenten",
        "Komunikat błędu": "Fehlermeldung",
        "Komunikat walidacji": "Validierungsmeldung",
        "Konfiguracja": "Konfiguration",
        "Konfiguracja etapu": "Phasenkonfiguration",
        "Konfiguracja kolumn tabeli": "Konfiguration der Tabellenspalten",
        "Konfiguracja listy": "Listenkonfiguration",
        "Konfiguracja modelu": "Modellkonfiguration",
        "Konfiguracja połączenia": "Verbindungskonfiguration",
        "Konfiguracja zaawansowana": "Erweiterte Konfiguration",
        "Konfiguracja zapytania": "Abfragekonfiguration",
        "Koniec pętli": "Schleifenende",
        "Konstruktor": "Konstruktor",
        "Konta użytkowników": "Benutzerkonten",
        "Kontrolka": "Steuerelement",
        "Kontrolka dostępna publicznie": "Öffentlich verfügbares Steuerelement",
        "Kontrolka jest obsługiwana na publicu.": "Das Steuerelement wird im öffentlichen Bereich unterstützt.",
        "Kontrolka wyboru (pojedynczy wybór, value jest skrótem pobierającym pierwszy element z tablicy data)": "Auswahlsteuerelement (Einzelauswahl; value ist eine Kurzform, die das erste Element aus dem data-Array abruft)",
        "Kontrolka wyboru (wybór wielokrotny)": "Auswahlsteuerelement (Mehrfachauswahl)",
        "Kontrolka wysyła zapytanie HTTP do zewnętrznego serwera i zwraca status oraz treść odpowiedzi.": "Das Steuerelement sendet eine HTTP-Anfrage an einen externen Server und gibt den Status sowie den Antwortinhalt zurück.",
        "Konwertuj obrazy do formatu WebP": "Bilder in das WebP-Format konvertieren",
        "Kopiuj": "Kopieren",
        "Kopiuj adres": "Adresse kopieren",
        "Kopiuj dane": "Daten kopieren",
        "Kopiuj definicję": "Definition kopieren",
        "Kopiuj endpoint": "Endpunkt kopieren",
        "Kopiuj klucz": "Schlüssel kopieren",
        "Kopiuj URL": "URL kopieren",
        "Kraj": "Land",
        "Kreator modułu": "Modul-Assistent",
        "Krok minut": "Minutenschritt",
        "Krok minut musi być liczbą z zakresu od 1 do 60.": "Der Minutenschritt muss eine Zahl zwischen 1 und 60 sein.",
        "Kroki": "Schritte",
        "Kroki kreatora": "Assistentenschritte",
        "Krótka informacja o przeznaczeniu źródła.": "Kurze Information zum Verwendungszweck der Quelle.",
        "Krótki opis": "Kurzbeschreibung",
        "Łączenie treści": "Inhalte zusammenführen",
        "Liczba": "Zahl",
        "Liczba całkowita": "Ganzzahl",
        "Liczba dziesiętna": "Dezimalzahl",
        "Liczba rekordów (Count)": "Anzahl der Datensätze (Count)",
        "Liczba wyników": "Anzahl der Ergebnisse",
        "Liczba zmiennoprzecinkowa": "Gleitkommazahl",
        "Linia": "Zeile",
        "Lista": "Liste",
        "Lista elementów zostanie zawężona tylko do tych, które są pozwiązane z wybranymi wartościami z zaznaczonych komponentów.": "Die Liste der Elemente wird auf diejenigen beschränkt, die mit den ausgewählten Werten der markierten Komponenten verknüpft sind.",
        "Lista ID": "ID-Liste",
        "Lista rekordów (ToList)": "Datensatzliste (ToList)",
        "Lista rozszerzeń oddzielona przecinkami.": "Kommagetrennte Liste der Erweiterungen.",
        "Lista rozwijalna": "Dropdown-Liste",
        "Lista sortowalna": "Sortierbare Liste",
        "Litery": "Buchstaben",
        "Litery i cyfry": "Buchstaben und Zahlen",
        "Logi": "Protokolle",
        "Lokalizacja": "Standort",
        "Lokalizowane": "Lokalisiert",
        "Long": "Long",
        "lub obiekt JSON.": "oder ein JSON-Objekt.",
        "Maksimum": "Maximum",
        "Maksymalna ilość plików": "Maximale Anzahl von Dateien",
        "Maksymalna rozdzielczość po optymalizacji: %0 × %1 px.": "Maximale Auflösung nach der Optimierung: %0 × %1 px.",
        "Maksymalny rozmiar pliku w MB": "Maximale Dateigröße in MB",
        "Maksymalny rozmiar pojedynczego pliku": "Maximale Größe einer einzelnen Datei",
        "Małe litery": "Kleinbuchstaben",
        "Małe znaki": "Kleinbuchstaben",
        "Malejąco": "Absteigend",
        "Mały": "Klein",
        "Mały układ siatki": "Kleines Rasterlayout",
        "Mapa": "Karte",
        "Mapowanie": "Zuordnung",
        "Mapowanie danych": "Datenzuordnung",
        "Mapowanie wartości": "Wertzuordnung",
        "Mapowanie, filtrowanie, sortowanie i usuwanie duplikatów zwracają listę. Grupowanie zwraca obiekt grup, sumowanie liczbę, a dzielenie na paczki listę list.": "Zuordnen, Filtern, Sortieren und Entfernen von Duplikaten geben eine Liste zurück. Gruppieren gibt ein Gruppenobjekt zurück, Summieren eine Zahl und Aufteilen in Pakete eine Liste von Listen.",
        "Mediana": "Median",
        "Metadane dokumentu": "Dokumentmetadaten",
        "Metoda": "Methode",
        "Metoda HTTP": "HTTP-Methode",
        "Metoda HTTP wymagana przy wywołaniu webhooka.": "Die beim Aufruf des Webhooks erforderliche HTTP-Methode.",
        "Metoda żądania HTTP": "HTTP-Anfragemethode",
        "Miejsca po przecinku": "Dezimalstellen",
        "Miejsca publikacji": "Veröffentlichungsorte",
        "Miejscowość": "Ort",
        "miesiąc": "Monat",
        "Miesiąc": "Monat",
        "Minimalna ilość plików": "Mindestanzahl von Dateien",
        "Minimalna szerokość": "Mindestbreite",
        "Minimapa": "Übersichtskarte",
        "Minimum": "Minimum",
        "Mniejsze lub równe": "Kleiner oder gleich",
        "Mniejsze niż": "Kleiner als",
        "Mnożenie": "Multiplikation",
        "Model danych": "Datenmodell",
        "Model danych i cechy można skonfigurować tylko podczas dodawania nowego formularza.": "Datenmodell und Eigenschaften können nur beim Hinzufügen eines neuen Formulars konfiguriert werden.",
        "Model danych wynika z definicji wybranego formularza. Aby użyć innego modelu, wybierz odpowiedni formularz.": "Das Datenmodell ergibt sich aus der Definition des ausgewählten Formulars. Um ein anderes Modell zu verwenden, wählen Sie das entsprechende Formular aus.",
        "Model określa tabelę, z której zostaną pobrane dane.": "Das Modell bestimmt die Tabelle, aus der die Daten abgerufen werden.",
        "Model określony przez wybrany formularz.": "Das durch das ausgewählte Formular definierte Modell.",
        "Moduł": "Modul",
        "Moduł dynamiczny": "Dynamisches Modul",
        "Moduł i sekcja": "Modul und Abschnitt",
        "Moduł niedostępny": "Modul nicht verfügbar",
        "Moduł został dodany.": "Das Modul wurde hinzugefügt.",
        "Moduł został usunięty.": "Das Modul wurde gelöscht.",
        "Moduł został wyeksportowany.": "Das Modul wurde exportiert.",
        "Moduł został zaktualizowany.": "Das Modul wurde aktualisiert.",
        "module.": "Modul.",
        "Moduły": "Module",
        "Moduły dynamiczne": "Dynamische Module",
        "Modyfikacja dokumentów": "Dokumente bearbeiten",
        "Modyfikacja dokumentu w module": "Dokument im Modul bearbeiten",
        "Modyfikacja rekordu w bazie danych": "Datensatz in der Datenbank bearbeiten",
        "Moje dokumenty": "Meine Dokumente",
        "Moje punkty": "Meine Punkte",
        "Moje wydarzenia": "Meine Ereignisse",
        "Możliwość wielokrotnego wyboru": "Mehrfachauswahl",
        "Multimedia": "Multimedia",
        "Na wejściu należy podać dane wejściowe, a następnie zadeklarować": "Als Eingabe müssen Eingabedaten angegeben und anschließend deklariert werden",
        "Na wyjściu zwracana jest encja wybranego modelu danych.": "Als Ausgabe wird die Entität des ausgewählten Datenmodells zurückgegeben.",
        "Na wyjściu zwracany jest model wpisu wybranego formularza dynamicznego.": "Als Ausgabe wird das Eintragsmodell des ausgewählten dynamischen Formulars zurückgegeben.",
        "Nadawanie uprawnień do dokumentów": "Berechtigungen für Dokumente vergeben",
        "Nadawanie uprawnień do własnych dokumentów": "Berechtigungen für eigene Dokumente vergeben",
        "Nadawanie uprawnień do wszystkich dokumentów": "Berechtigungen für alle Dokumente vergeben",
        "Nagłówek": "Kopfzeile",
        "Nagłówki": "Kopfzeilen",
        "Nagłówki cache": "Cache-Header",
        "Najmniejsza wartość (Min)": "Kleinster Wert (Min)",
        "Najpierw wczytaj plik CSV.": "Laden Sie zuerst die CSV-Datei.",
        "Największa wartość (Max)": "Größter Wert (Max)",
        "Należy wybrać model danych.": "Ein Datenmodell muss ausgewählt werden.",
        "Należy wybrać przynajmniej jedną akcję.": "Es muss mindestens eine Aktion ausgewählt werden.",
        "Należy wybrać przynajmniej jedną właściwość modelu.": "Es muss mindestens eine Modelleigenschaft ausgewählt werden.",
        "Należy zapisać zmiany w scenariuszu przed uruchomieniem procesu.": "Speichern Sie die Änderungen am Szenario, bevor Sie den Prozess starten.",
        "Narzędzia scenariusza": "Szenario-Tools",
        "Następny": "Weiter",
        "Nazwa": "Name",
        "Nazwa akcji": "Aktionsname",
        "Nazwa etapu": "Name der Phase",
        "Nazwa formularza": "Formularname",
        "Nazwa i ikona pomagają odnaleźć komponent w przyborniku formularza.": "Name und Symbol helfen dabei, die Komponente in der Formular-Toolbox zu finden.",
        "Nazwa jest wymagana": "Der Name ist erforderlich",
        "Nazwa kategorii": "Kategoriename",
        "Nazwa kolumny": "Spaltenname",
        "Nazwa kolumny z obrazem": "Name der Bildspalte",
        "Nazwa kolumny z opisem": "Name der Beschreibungsspalte",
        "Nazwa kolumny z wartością": "Name der Wertespalte",
        "Nazwa komponentu": "Komponentenname",
        "Nazwa kontrolki": "Name des Steuerelements",
        "Nazwa modelu": "Modellname",
        "Nazwa modułu": "Modulname",
        "Nazwa modułu w panelu.": "Name des Moduls im Panel.",
        "Nazwa musi mieć co najmniej 3 znaki": "Der Name muss mindestens 3 Zeichen lang sein",
        "Nazwa musi mieć co najmniej 4 znaki": "Der Name muss mindestens 4 Zeichen lang sein",
        "Nazwa nie może być dłuższa niż 30 znaków": "Der Name darf nicht länger als 30 Zeichen sein",
        "Nazwa nie może być dłuższy niż 50 znaków": "Der Name darf nicht länger als 50 Zeichen sein",
        "Nazwa pola": "Feldname",
        "Nazwa pola jest wymagana": "Der Feldname ist erforderlich",
        "Nazwa przycisku ``Dalej``": "Name der Schaltfläche ``Weiter``",
        "Nazwa przycisku ``Wstecz``": "Name der Schaltfläche ``Zurück``",
        "Nazwa przycisku ``Wyślij``": "Name der Schaltfläche ``Senden``",
        "Nazwa scenariusza": "Szenarioname",
        "Nazwa sekcji w menu": "Name des Abschnitts im Menü",
        "Nazwa sekcji w wybranym języku.": "Name des Abschnitts in der ausgewählten Sprache.",
        "Nazwa sekcji widoczna w menu modułu.": "Name des Abschnitts, der im Modulmenü angezeigt wird.",
        "Nazwa sekcji: A–Z": "Name des Abschnitts: A–Z",
        "Nazwa sekcji: Z–A": "Name des Abschnitts: Z–A",
        "Nazwa techniczna": "Technischer Name",
        "Nazwa ułatwiająca rozpoznanie webhooka na liście w panelu.": "Ein Name, mit dem der Webhook in der Liste im Panel leicht zu erkennen ist.",
        "Nazwa uprawnienia": "Berechtigungsname",
        "Nazwa warunku jest wymagana": "Der Name der Bedingung ist erforderlich",
        "Nazwa warunku musi być unikalna": "Der Name der Bedingung muss eindeutig sein",
        "Nazwa warunku musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "Der Name der Bedingung muss mit einem Kleinbuchstaben beginnen und darf nur alphanumerische Zeichen enthalten",
        "nazwa warunku...": "Name der Bedingung...",
        "Nazwa webhooka": "Webhook-Name",
        "Nazwa widoczna na liście źródeł danych.": "Name, der in der Liste der Datenquellen angezeigt wird.",
        "Nazwa wyświetlana": "Anzeigename",
        "Nazwa wyświetlana w przyborniku formularza.": "Name, der in der Formular-Toolbox angezeigt wird.",
        "Nazwa wyświetlana: A–Z": "Anzeigename: A–Z",
        "Nazwa wyświetlana: Z–A": "Anzeigename: Z–A",
        "Nazwa zdarzenia": "Ereignisname",
        "Nazwa zmiennej jest wymagana": "Der Variablenname ist erforderlich",
        "Nazwa zmiennej musi być unikalna": "Der Variablenname muss eindeutig sein",
        "nazwa zmiennej...": "Variablenname...",
        "Nazwa źródła": "Quellenname",
        "Nazwa źródła danych": "Name der Datenquelle",
        "Nazwa, identyfikator i kategoria modułu.": "Name, ID und Kategorie des Moduls.",
        "Nazwę zmiennej umieść między dwoma znakami": "Setzen Sie den Variablennamen zwischen zwei Zeichen",
        "Nazwisko": "Nachname",
        "Nazwy wartości": "Wertnamen",
        "Nazwy właściwości modelu": "Namen der Modelleigenschaften",
        "Nazwy właściwości niezmiennych": "Namen unveränderlicher Eigenschaften",
        "Nie": "Nein",
        "Nie dotyczy plików SVG.": "Gilt nicht für SVG-Dateien.",
        "Nie masz uprawnień do edycji tego modułu.": "Sie sind nicht berechtigt, dieses Modul zu bearbeiten.",
        "Nie masz uprawnień do tego dokumentu": "Sie sind nicht berechtigt, auf dieses Dokument zuzugreifen",
        "Nie można tworzyć zapętlonych powiązań.": "Zyklische Verknüpfungen können nicht erstellt werden.",
        "Nie można zapisać zmian ponieważ skrypt się nie kompiluje.": "Die Änderungen können nicht gespeichert werden, da das Skript nicht kompiliert werden kann.",
        "Nie podano wymaganej ilości znaków: %0.": "Die erforderliche Zeichenanzahl wurde nicht angegeben: %0.",
        "Nie podano wymaganej ilości znaków: %0. (%1)": "Die erforderliche Zeichenanzahl wurde nicht angegeben: %0. (%1)",
        "Nie udało się odczytać pliku CSV.": "Die CSV-Datei konnte nicht gelesen werden.",
        "Nie udało się pobrać danych do porównania.": "Die Daten für den Vergleich konnten nicht abgerufen werden.",
        "Nie udało się pobrać definicji formularzy.": "Die Formulardefinitionen konnten nicht abgerufen werden.",
        "Nie udało się pobrać endpointów.": "Die Endpunkte konnten nicht abgerufen werden.",
        "Nie udało się pobrać kategorii.": "Die Kategorien konnten nicht abgerufen werden.",
        "Nie udało się pobrać komponentów.": "Die Komponenten konnten nicht abgerufen werden.",
        "Nie udało się pobrać listy modułów Studio.": "Die Liste der Studio-Module konnte nicht abgerufen werden.",
        "Nie udało się pobrać modułów.": "Die Module konnten nicht abgerufen werden.",
        "Nie udało się pobrać opublikowanej definicji formularza.": "Die veröffentlichte Formulardefinition konnte nicht abgerufen werden.",
        "Nie udało się pobrać scenariuszy.": "Die Szenarien konnten nicht abgerufen werden.",
        "Nie udało się pobrać ustawień kont użytkowników": "Die Einstellungen der Benutzerkonten konnten nicht abgerufen werden",
        "Nie udało się pobrać ustawień pól dodatkowych.": "Die Einstellungen der zusätzlichen Felder konnten nicht abgerufen werden.",
        "Nie udało się pobrać webhooka.": "Der Webhook konnte nicht abgerufen werden.",
        "Nie udało się pobrać webhooków.": "Die Webhooks konnten nicht abgerufen werden.",
        "Nie udało się pobrać wersji formularza.": "Die Formularversion konnte nicht abgerufen werden.",
        "Nie udało się pobrać źródeł danych.": "Die Datenquellen konnten nicht abgerufen werden.",
        "Nie udało się pobrać źródła danych.": "Die Datenquelle konnte nicht abgerufen werden.",
        "Nie udało się przygotować podglądu szablonu. Spróbuj ponownie.": "Die Vorschau der Vorlage konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
        "Nie udało się skopiować adresu URL.": "Die URL konnte nicht kopiert werden.",
        "Nie udało się skopiować adresu.": "Die Adresse konnte nicht kopiert werden.",
        "Nie udało się skopiować danych.": "Die Daten konnten nicht kopiert werden.",
        "Nie udało się skopiować definicji.": "Die Definition konnte nicht kopiert werden.",
        "Nie udało się skopiować klucza.": "Der Schlüssel konnte nicht kopiert werden.",
        "Nie udało się skopiować wyniku.": "Das Ergebnis konnte nicht kopiert werden.",
        "Nie udało się uruchomić procesu.": "Der Prozess konnte nicht gestartet werden.",
        "Nie udało się usunąć {count} kategorii. Pozostały zaznaczone.": "{count} Kategorien konnten nicht gelöscht werden. Sie bleiben ausgewählt.",
        "Nie udało się usunąć scenariuszy: {count}.": "Die Szenarien konnten nicht gelöscht werden: {count}.",
        "Nie udało się wczytać definicji formularza.": "Die Formulardefinition konnte nicht geladen werden.",
        "Nie udało się wczytać definicji formularza. Spróbuj ponownie.": "Die Formulardefinition konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
        "Nie udało się wczytać formularza.": "Das Formular konnte nicht geladen werden.",
        "Nie udało się wczytać historii scenariusza.": "Der Szenarioverlauf konnte nicht geladen werden.",
        "Nie udało się wczytać komponentów.": "Die Komponenten konnten nicht geladen werden.",
        "Nie udało się wczytać kontrolki złożonej.": "Das zusammengesetzte Steuerelement konnte nicht geladen werden.",
        "Nie udało się wczytać kontrolki złożonej. Jej zapisane źródło nie jest dostępne.": "Das zusammengesetzte Steuerelement konnte nicht geladen werden. Seine gespeicherte Quelle ist nicht verfügbar.",
        "Nie udało się wczytać listy modułów.": "Die Modulliste konnte nicht geladen werden.",
        "Nie udało się wczytać modułu": "Das Modul konnte nicht geladen werden",
        "Nie udało się wczytać modułu.": "Das Modul konnte nicht geladen werden.",
        "Nie udało się wczytać modułu. Spróbuj ponownie.": "Das Modul konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
        "Nie udało się wczytać operacji.": "Die Operationen konnten nicht geladen werden.",
        "Nie udało się wczytać powtórzeń operacji.": "Die Wiederholungen der Operation konnten nicht geladen werden.",
        "Nie udało się wczytać szablonu.": "Die Vorlage konnte nicht geladen werden.",
        "Nie udało się wczytać szczegółów procesu.": "Die Prozessdetails konnten nicht geladen werden.",
        "Nie udało się wygenerować formularza": "Das Formular konnte nicht generiert werden",
        "Nie udało się zaimportować pliku CSV.": "Die CSV-Datei konnte nicht importiert werden.",
        "Nie usunięto formularzy": "Die Formulare wurden nicht gelöscht",
        "Nie wybrano pliku": "Keine Datei ausgewählt",
        "Nie wybrano użytkownika.": "Kein Benutzer ausgewählt.",
        "Nie zaleca się włączać tej opcji dla formularza z istniejącymi dokumentami.": "Es wird nicht empfohlen, diese Option für ein Formular mit vorhandenen Dokumenten zu aktivieren.",
        "Nie znaleziono formularza.": "Das Formular wurde nicht gefunden.",
        "Nieaktywny": "Inaktiv",
        "Nienazwane uprawnienie": "Unbenannte Berechtigung",
        "Niepoprawne wyrażenie regularne": "Ungültiger regulärer Ausdruck",
        "Nieprawidłowa definicja": "Ungültige Definition",
        "Niestandardowe logo i stopka": "Benutzerdefiniertes Logo und Fußzeile",
        "Niestandardowy błąd": "Benutzerdefinierter Fehler",
        "Niewidoczne": "Nicht sichtbar",
        "Nieznany": "Unbekannt",
        "Nieznany typ": "Unbekannter Typ",
        "Nigdy": "Nie",
        "Niska": "Niedrig",
        "no-store (wyłącza cache)": "no-store (deaktiviert den Cache)",
        "Nowa data": "Neues Datum",
        "Nowa sekcja": "Neuer Abschnitt",
        "Nowy moduł": "Neues Modul",
        "Nowy moduł dynamiczny": "Neues dynamisches Modul",
        "np. Formularz kontaktowy": "z. B. Kontaktformular",
        "np. Powiadomienie o zamówieniu": "z. B. Bestellbenachrichtigung",
        "Numer domu": "Hausnummer",
        "Numer mieszkania": "Wohnungsnummer",
        "Obiekt JSON": "JSON-Objekt",
        "Obok siebie": "Nebeneinander",
        "Obraz": "Bild",
        "Obraz wyniku na podstawie ID z SQL.": "Ergebnisbild anhand der ID aus SQL.",
        "Obsługiwane kanały": "Unterstützte Kanäle",
        "Obsługiwane powiadomienia": "Unterstützte Benachrichtigungen",
        "Obsługiwane są wszystkie powiadomienia.": "Alle Benachrichtigungen werden unterstützt.",
        "od": "von",
        "Od": "Von",
        "od %0": "ab %0",
        "Odblokuj edycję diagramu": "Diagrammbearbeitung entsperren",
        "Oddzielne uprawnienia do dostępu, edycji, usuwania, akceptacji i nadawania uprawnień do dokumentów.": "Separate Berechtigungen für den Zugriff auf, die Bearbeitung und das Löschen von Dokumenten sowie für deren Freigabe und die Vergabe von Berechtigungen.",
        "Odejmowanie": "Subtraktion",
        "odpowiada parametr": "entspricht dem Parameter",
        "Odpowiedź dowolna": "Beliebige Antwort",
        "Odpowiedzi": "Antworten",
        "Odpowiedzi: %0 na %1": "Antworten: %0 von %1",
        "Odstęp": "Abstand",
        "Odśwież": "Aktualisieren",
        "Omnitool": "Omnitool",
        "Opcja %0": "Option %0",
        "Opcje": "Optionen",
        "Opcjonalnie wskaż pole i kierunek sortowania. Ma to znaczenie zwłaszcza przy wyborze pierwszego rekordu.": "Geben Sie optional ein Feld und eine Sortierrichtung an. Dies ist besonders wichtig, wenn der erste Datensatz ausgewählt wird.",
        "Opcjonalnie wybierz pola, które mają znaleźć się w wyniku. Bez mapowania zwracany jest pełny rekord.": "Wählen Sie optional die Felder aus, die im Ergebnis enthalten sein sollen. Ohne Zuordnung wird der vollständige Datensatz zurückgegeben.",
        "Opcjonalny warunek Dynamic LINQ. Podaj wyrażenie bez nazwy parametru lambda.": "Optionale Dynamic-LINQ-Bedingung. Geben Sie den Ausdruck ohne den Namen des Lambda-Parameters an.",
        "Operacja": "Operation",
        "Operacja określa format wyniku: pojedynczą wartość, pierwszy rekord albo listę rekordów.": "Die Operation bestimmt das Ergebnisformat: einen einzelnen Wert, den ersten Datensatz oder eine Liste von Datensätzen.",
        "Operacje": "Operationen",
        "Operacje w pętli": "Schleifenoperationen",
        "Operacje wykonane": "Ausgeführte Operationen",
        "Operator": "Operator",
        "Opis": "Beschreibung",
        "Opis błędu": "Fehlerbeschreibung",
        "Opis źródła": "Quellbeschreibung",
        "Opisz formularz": "Formular beschreiben",
        "Opisz, jakie pola powinny znajdować się w formularzu.": "Beschreiben Sie, welche Felder im Formular enthalten sein sollen.",
        "Optymalizacja obrazów": "Bildoptimierung",
        "Optymalizuj rozdzielczość obrazów": "Bildauflösung optimieren",
        "Ostatnia aktywność: {0}": "Letzte Aktivität: {0}",
        "Ostatnio używane": "Kürzlich verwendet",
        "Ostrzeżenie": "Warnung",
        "Otwórz edytor wyrażenia.": "Ausdruckseditor öffnen.",
        "Otwórz formularz": "Formular öffnen",
        "Oznaczenie modułu w nawigacji.": "Modulkennzeichnung in der Navigation.",
        "Pamięć podręczna": "Cache",
        "Panel projektu": "Projektübersicht",
        "Parametry query": "Query-Parameter",
        "Parametry wejściowe pochodzą z innych podpiętych widgetów.": "Eingabeparameter stammen aus anderen verbundenen Widgets.",
        "Parametry wejściowe skryptu": "Skripteingabeparameter",
        "Parametry wymagane do wykonania zapytania": "Für die Ausführung der Abfrage erforderliche Parameter",
        "Parser Liquid": "Liquid-Parser",
        "Pasek": "Leiste",
        "Pasek postępu": "Fortschrittsbalken",
        "Pełna kontrola nad właściwościami sekcji, uprawnieniami oraz endpointami API.": "Volle Kontrolle über Abschnittseigenschaften, Berechtigungen und API-Endpunkte.",
        "Pełna treść wiadomości": "Vollständiger Nachrichtentext",
        "Pełny": "Vollständig",
        "Pełny dokument": "Vollständiges Dokument",
        "Pierwiastkowanie wartości kolumny": "Wurzelziehen des Spaltenwerts",
        "Pierwsza sekcja pozostaje widoczna.": "Der erste Abschnitt bleibt sichtbar.",
        "Pierwszy rekord (FirstOrDefault)": "Erster Datensatz (FirstOrDefault)",
        "Pierwszy wiersz jest nagłówkiem": "Die erste Zeile ist die Kopfzeile",
        "Pigułki": "Chips",
        "Placeholder": "Platzhalter",
        "Plik": "Datei",
        "Plik CSV nie zawiera danych.": "Die CSV-Datei enthält keine Daten.",
        "Pliki": "Dateien",
        "Pliki: %0": "Dateien: %0",
        "po elementach kolekcji": "nach Sammlungselementen",
        "Pobieranie dokumentów": "Dokumente abrufen",
        "Pobieranie dokumentu": "Dokument abrufen",
        "Pobieranie encji": "Entität abrufen",
        "Pobieranie i aktualizacja encji": "Entität abrufen und aktualisieren",
        "Pobieranie i usuwanie encji": "Entität abrufen und löschen",
        "Pobieranie listy encji": "Entitätenliste abrufen",
        "Pobierz załącznik: {name}": "Anhang herunterladen: {name}",
        "Początek pętli": "Schleifenbeginn",
        "Początkowa ilość wierszy": "Anzahl der anfänglichen Zeilen",
        "Podaj ID dokumentu lub nazwę parametru wejściowego.": "Geben Sie die Dokument-ID oder den Namen des Eingabeparameters an.",
        "Podaj nazwę formularza": "Formularnamen eingeben",
        "Podaj nazwę scenariusza": "Szenarionamen eingeben",
        "Podaj nową nazwę": "Neuen Namen eingeben",
        "Podajemy go w formie jednoliniowej. Przykład:": "Wir geben ihn in einer einzeiligen Form an. Beispiel:",
        "Podana nazwa jest zajęta.": "Der angegebene Name ist bereits vergeben.",
        "Podana wartość jest nieprawidłowa.": "Der angegebene Wert ist ungültig.",
        "Podane ręcznie": "Manuell angegeben",
        "Podanie nazwy jest wymagane.": "Die Angabe eines Namens ist erforderlich.",
        "Podano adres": "Adresse angegeben",
        "Podano nieprawidłowe dane": "Ungültige Daten angegeben",
        "Podano nieprawidłowe dane.": "Ungültige Daten angegeben.",
        "Podano nieprawidłowe dane. (%0)": "Ungültige Daten angegeben. (%0)",
        "Podgląd": "Vorschau",
        "Podgląd formularza": "Formularvorschau",
        "Podgląd kalendarza": "Kalendervorschau",
        "Podgląd listy": "Listenansicht",
        "Podgląd mapy": "Kartenvorschau",
        "Podgląd modułu": "Modulvorschau",
        "Podgląd tabeli": "Tabellenvorschau",
        "Podgląd wyniku jest niedostępny. Aby zobaczyć podgląd, scenariusz musi się wykonać poprawnie przynajmniej jeden raz.": "Die Ergebnisvorschau ist nicht verfügbar. Damit eine Vorschau angezeigt werden kann, muss das Szenario mindestens einmal erfolgreich ausgeführt worden sein.",
        "Podgląd wyniku wybranego etapu": "Vorschau des Ergebnisses des ausgewählten Schritts",
        "Podpis": "Beschriftung",
        "Podpis modułu w wybranym języku.": "Modulbeschriftung in der ausgewählten Sprache.",
        "Podproces": "Unterprozess",
        "Podstawowe": "Allgemein",
        "Podstawowe operacje na datach": "Grundlegende Datumsoperationen",
        "Podstawowe operacje na liczbach": "Grundlegende Zahlenoperationen",
        "Podstawowe operacje tekstowe": "Grundlegende Textoperationen",
        "Podstawowe operacje warunkowe": "Grundlegende Bedingungsoperationen",
        "Podsumowanie procesu": "Prozessübersicht",
        "Pojedynczy": "Einzeln",
        "Pojedynczy formularz": "Einzelnes Formular",
        "Pokaż": "Anzeigen",
        "Pokaż etykietę": "Beschriftung anzeigen",
        "Pokaż filtr w domyślnym widoku.": "Filter in der Standardansicht anzeigen.",
        "Pokaż kolumnę w domyślnym widoku.": "Spalte in der Standardansicht anzeigen.",
        "Pokaż numery stron": "Seitennummern anzeigen",
        "Pokaż numery tygodnia na kalendarzu": "Kalenderwochen anzeigen",
        "Pokaż przycisk ``Wyślij``": "Schaltfläche ``Senden`` anzeigen",
        "Pokaż starsze wersje": "Ältere Versionen anzeigen",
        "Pokaż tytuł formularza": "Formulartitel anzeigen",
        "Pokaż tytuł sekcji": "Abschnittstitel anzeigen",
        "Pokaż tytuł strony": "Seitentitel anzeigen",
        "Pokaż tytuły stron": "Seitentitel anzeigen",
        "Pokaż więcej": "Mehr anzeigen",
        "Pokaż więcej komponentów": "Weitere Komponenten anzeigen",
        "pół roku": "ein halbes Jahr",
        "Pola": "Felder",
        "Pola obsługiwane przez generator dynamicznych formularzy.": "Vom Generator für dynamische Formulare unterstützte Felder.",
        "Pola w formularzu": "Formularfelder",
        "Pola z wybranego formularza pojawią się w edytorze konta.": "Die Felder aus dem ausgewählten Formular werden im Konto-Editor angezeigt.",
        "Pole": "Feld",
        "Pole \"%0\" jest wymagane.": "Das Feld \"%0\" ist erforderlich.",
        "Pole \"%0\" jest wymagane. (%1)": "Das Feld \"%0\" ist erforderlich. (%1)",
        "Pole \"%0\" nie zawiera prawidłowego adresu email.": "Das Feld \"%0\" enthält keine gültige E-Mail-Adresse.",
        "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "Das Feld \"%0\" enthält keine gültige URL.",
        "Pole \"%0\" wymaga uzupełnienia wszystkich elementów": "Für das Feld \"%0\" müssen alle Elemente ausgefüllt werden",
        "Pole \"%0\" zawiera niedozwoloną wartość.": "Das Feld \"%0\" enthält einen unzulässigen Wert.",
        "Pole \"%0\" zawiera nieprawidłowy symbol.": "Das Feld \"%0\" enthält ein ungültiges Zeichen.",
        "Pole \"Akcje\" jest wymagane.": "Das Feld \"Aktionen\" ist erforderlich.",
        "Pole \"Drugie imię\" jest wymagane.": "Das Feld \"Zweiter Vorname\" ist erforderlich.",
        "Pole \"Id dokumentu\" jest wymagane.": "Das Feld \"Dokument-ID\" ist erforderlich.",
        "Pole \"Id encji\" jest wymagane.": "Das Feld \"Entitäts-ID\" ist erforderlich.",
        "Pole \"Imię\" jest wymagane.": "Das Feld \"Vorname\" ist erforderlich.",
        "Pole \"Liczba wyników\" jest wymagane.": "Das Feld \"Anzahl der Ergebnisse\" ist erforderlich.",
        "Pole \"Model\" jest wymagane.": "Das Feld \"Modell\" ist erforderlich.",
        "Pole \"Moduł dynamiczny\" jest wymagane.": "Das Feld \"Dynamisches Modul\" ist erforderlich.",
        "Pole \"Moduł\" jest wymagane.": "Das Feld \"Modul\" ist erforderlich.",
        "Pole \"Nazwa modelu\" jest wymagane.": "Das Feld \"Modellname\" ist erforderlich.",
        "Pole \"Nazwa zdarzenia\" jest wymagane.": "Das Feld \"Ereignisname\" ist erforderlich.",
        "Pole \"Nazwisko\" jest wymagane.": "Das Feld \"Nachname\" ist erforderlich.",
        "Pole \"Operacja\" jest wymagane.": "Das Feld \"Vorgang\" ist erforderlich.",
        "Pole \"Podproces\" jest wymagane.": "Das Feld \"Teilprozess\" ist erforderlich.",
        "Pole \"Pole agregacji\" jest wymagane dla tej operacji.": "Das Feld \"Aggregationsfeld\" ist für diesen Vorgang erforderlich.",
        "Pole \"Pole\" jest wymagane.": "Das Feld \"Feld\" ist erforderlich.",
        "Pole \"Sekcja modułu\" jest wymagane.": "Das Feld \"Modulbereich\" ist erforderlich.",
        "Pole \"Sekcja\" jest wymagane.": "Das Feld \"Bereich\" ist erforderlich.",
        "Pole \"Skrypt wykonywalny\" jest wymagane.": "Das Feld \"Ausführbares Skript\" ist erforderlich.",
        "Pole \"Typ agregacji\" jest wymagane.": "Das Feld \"Aggregationstyp\" ist erforderlich.",
        "Pole \"Tytuł\" jest wymagane.": "Das Feld \"Titel\" ist erforderlich.",
        "Pole \"Wyrażenie EQL\" jest wymagane.": "Das Feld \"EQL-Ausdruck\" ist erforderlich.",
        "Pole agregacji": "Aggregationsfeld",
        "Pole jest wymagane": "Das Feld ist erforderlich",
        "Pole może zawierać jedynie cyfry.": "Das Feld darf nur Ziffern enthalten.",
        "Pole może zawierać jedynie cyfry. (%0)": "Das Feld darf nur Ziffern enthalten. (%0)",
        "Pole może zawierać jedynie litery i cyfry.": "Das Feld darf nur Buchstaben und Ziffern enthalten.",
        "Pole może zawierać jedynie litery i cyfry. (%0)": "Das Feld darf nur Buchstaben und Ziffern enthalten. (%0)",
        "Pole może zawierać jedynie litery.": "Das Feld darf nur Buchstaben enthalten.",
        "Pole może zawierać jedynie litery. (%0)": "Das Feld darf nur Buchstaben enthalten. (%0)",
        "Pole typu \"%0\" jest niedozwolone w tym formularzu.": "Ein Feld vom Typ \"%0\" ist in diesem Formular nicht zulässig.",
        "Pole wymaga podania przynajmniej jednego znaku specjalnego.": "Das Feld muss mindestens ein Sonderzeichen enthalten.",
        "Pole wymaga podania przynajmniej jednej cyfry.": "Das Feld muss mindestens eine Ziffer enthalten.",
        "Pole wymaga podania przynajmniej jednej dużej litery.": "Das Feld muss mindestens einen Großbuchstaben enthalten.",
        "Pole wymaga podania przynajmniej jednej małej litery.": "Das Feld muss mindestens einen Kleinbuchstaben enthalten.",
        "Pole wymagane": "Pflichtfeld",
        "Pole zawiera": "Das Feld enthält",
        "Pomniejsz": "Verkleinern",
        "Pomoc": "Hilfe",
        "Pomoc dotycząca walidacji": "Hilfe zur Validierung",
        "Ponów": "Erneut versuchen",
        "Poprawne": "Gültig",
        "Poprawny": "Gültig",
        "Poprzedni": "Vorheriger",
        "Porównaj wersje": "Versionen vergleichen",
        "Porównania": "Vergleiche",
        "Porównanie": "Vergleich",
        "Porównanie wersji": "Versionsvergleich",
        "Porównywana wersja": "Verglichene Version",
        "POST: Dowolne wyszukiwanie (Zapytanie EQL)": "POST: Beliebige Suche (EQL-Abfrage)",
        "POST: Upload załączników": "POST: Anhänge hochladen",
        "POST: Utworzenie wpisu": "POST: Eintrag erstellen",
        "POST: Zapisanie zmian": "POST: Änderungen speichern",
        "Postęp formularza": "Formularfortschritt",
        "Potwierdź akceptację": "Freigabe bestätigen",
        "Potwierdź usunięcie": "Löschen bestätigen",
        "Potwierdź usunięcie.": "Löschen bestätigen.",
        "Potwierdzenie usunięcia": "Löschbestätigung",
        "Powiadomienia": "Benachrichtigungen",
        "Powiadomienie jest wymagane": "Eine Benachrichtigung ist erforderlich",
        "Powiadomienie systemowe": "Systembenachrichtigung",
        "Powiązana kontrolka": "Zugehöriges Steuerelement",
        "Powiększ": "Vergrößern",
        "Powiększenie diagramu": "Diagramm vergrößern",
        "Powinno się dodać dyrektywę PRIVATE dla treści personalizowanych dla użytkownika, zwłaszcza dla odpowiedzi otrzymywanych po zalogowaniu i z uwzględnieniem uprawnień.": "Für nutzerbezogene Inhalte sollte die PRIVATE-Direktive verwendet werden, insbesondere für Antworten, die nach der Anmeldung und unter Berücksichtigung der Berechtigungen bereitgestellt werden.",
        "Powrót": "Zurück",
        "Powtórzenia": "Wiederholungen",
        "Poziom dostępu do webhooka": "Webhook-Zugriffsebene",
        "Poziom dostępu użytkownika": "Zugriffsebene des Benutzers",
        "Poziom uprawnień": "Berechtigungsstufe",
        "Pozostałe zaznaczenie zachowano.": "Die übrige Auswahl wurde beibehalten.",
        "pozwala na wykorzystanie zaawansowanego edytora tekstu.": "ermöglicht die Verwendung des erweiterten Texteditors.",
        "Pozwól na dodawanie wierszy": "Hinzufügen von Zeilen erlauben",
        "Pozwól na sortowanie wierszy": "Sortieren von Zeilen erlauben",
        "Pozycja na liście": "Listenposition",
        "Pozycje zostały zapisane.": "Die Positionen wurden gespeichert.",
        "Prezentacja": "Präsentation",
        "private (tylko cache przeglądarki)": "privat (nur Browser-Cache)",
        "Procent": "Prozent",
        "Proces": "Prozess",
        "Proces został uruchomiony.": "Der Prozess wurde gestartet.",
        "Projekt": "Projekt",
        "Prompt": "Prompt",
        "Prompt jest wymagany.": "Der Prompt ist erforderlich.",
        "Proste": "Einfach",
        "Proste uprawnienia": "Einfache Berechtigungen",
        "Prosty": "Einfach",
        "Przebieg procesu na diagramie": "Prozessablauf im Diagramm",
        "Przedrostek": "Präfix",
        "Przejdź do kolejnego kroku gdy:": "Zum nächsten Schritt wechseln, wenn:",
        "Przekroczono dozwoloną ilość znaków: %0.": "Die zulässige Zeichenanzahl wurde überschritten: %0.",
        "Przekroczono dozwoloną ilość znaków: %0. (%1)": "Die zulässige Zeichenanzahl wurde überschritten: %0. (%1)",
        "Przełącznik": "Schalter",
        "Przenieś filtr": "Filter verschieben",
        "Przenieś kolumnę": "Spalte verschieben",
        "Przenieś niżej": "Nach unten verschieben",
        "Przenieś sekcję": "Abschnitt verschieben",
        "Przenieś wiersz": "Zeile verschieben",
        "Przenieś wyżej": "Nach oben verschieben",
        "Przeniesienie wpisu do kosza": "Eintrag in den Papierkorb verschieben",
        "Przeniesione": "Verschoben",
        "Przeniesiono": "Verschoben",
        "Przerwany": "Abgebrochen",
        "Przesuń do góry": "Nach oben verschieben",
        "Przesuń na dół": "Nach unten verschieben",
        "Przybliżenie": "Zoom",
        "Przybornik": "Werkzeugkasten",
        "Przygotuj skrypt C#, korzystając z parametrów wejściowych pochodzących z podpiętych etapów. Aby sprawdzić poprawność kompilacji, użyj przycisku Build w zakładce Skrypt (C#). Wynik pojawi się w konsoli pod edytorem.": "Erstellen Sie ein C#-Skript unter Verwendung der Eingabeparameter aus den verknüpften Schritten. Um die Kompilierung zu überprüfen, verwenden Sie die Schaltfläche Build im Tab „Skript (C#)“. Das Ergebnis wird in der Konsole unter dem Editor angezeigt.",
        "Przykład dla rekordów o identyfikatorze zamówienia 1:": "Beispiel für Datensätze mit der Bestell-ID 1:",
        "Przykład kodu walidacji": "Beispiel für Validierungscode",
        "Przykład mapowania z wybranymi polami:": "Beispiel für eine Zuordnung mit ausgewählten Feldern:",
        "Przykład pola z ceną brutto:": "Beispiel für ein Feld mit Bruttopreis:",
        "Przykład walidacji": "Validierungsbeispiel",
        "Przykładowa struktura danych": "Beispielhafte Datenstruktur",
        "Przykłady": "Beispiele",
        "Przykłady konfiguracji": "Konfigurationsbeispiele",
        "Przypisz tablicę komunikatów do": "Weisen Sie das Nachrichtenarray zu",
        "przypisz wynik etapu...": "Schrittergebnis zuweisen...",
        "Przyrostek": "Suffix",
        "Przywrócenie wpisu z kosza": "Eintrag aus dem Papierkorb wiederherstellen",
        "public (cache przeglądarki i proxy)": "public (Browser- und Proxy-Cache)",
        "Punkt został zduplikowany.": "Der Punkt wurde dupliziert.",
        "Puste pole używa ikony modułu.": "Bei einem leeren Feld wird das Modulsymbol verwendet.",
        "PUT: Aktualizacja wpisu": "PUT: Eintrag aktualisieren",
        "Pytania": "Fragen",
        "Query string": "Query-String",
        "Radio": "Radio",
        "Reaguj na zmiany wybranych właściwości": "Auf Änderungen ausgewählter Eigenschaften reagieren",
        "Ręczne uruchomienie": "Manueller Start",
        "Reguła walidacji": "Validierungsregel",
        "Relacyjne": "Relational",
        "Renderer MJML": "MJML-Renderer",
        "Request body": "Request-Body",
        "REST API": "REST-API",
        "RESTful API": "RESTful-API",
        "Rezultat": "Ergebnis",
        "Rodzaj odpowiedzi": "Antworttyp",
        "Rodzaj pętli": "Schleifentyp",
        "Rodzaj zwracanego wyniku": "Typ des zurückgegebenen Ergebnisses",
        "rok": "Jahr",
        "Rok": "Jahr",
        "Rosnąco": "Aufsteigend",
        "Równe": "Gleich",
        "Równość": "Gleichheit",
        "Rozmiar obrazu": "Bildgröße",
        "Rozmiar okna dialog": "Dialogfenstergröße",
        "Rozmiar paczki": "Paketgröße",
        "Rozmiar paczki musi być większy od zera.": "Die Paketgröße muss größer als null sein.",
        "Rozmiar podawany w bajtach.": "Größe in Byte.",
        "Rozmieść równomiernie": "Gleichmäßig verteilen",
        "Różne": "Verschieden",
        "Rozwijane": "Dropdown",
        "Satysfakcja": "Zufriedenheit",
        "Scenariusz aktywny": "Szenario aktiv",
        "Scenariusz jest aktywowany po wywołaniu wybranego Webhooka.": "Das Szenario wird durch den Aufruf des ausgewählten Webhooks aktiviert.",
        "Scenariusz jest aktywowany po wywołaniu wybranego zdarzenia.": "Das Szenario wird durch das Auslösen des ausgewählten Ereignisses aktiviert.",
        "Scenariusz jest aktywowany według wybranego hamonogramu.": "Das Szenario wird nach dem ausgewählten Zeitplan aktiviert.",
        "Scenariusz został dodany.": "Das Szenario wurde hinzugefügt.",
        "Scenariusz został utworzony.": "Das Szenario wurde erstellt.",
        "Scenariusz został zaktualizowany.": "Das Szenario wurde aktualisiert.",
        "Ścieżka JSON": "JSON-Pfad",
        "Ścieżka JSON jest wymagana.": "Der JSON-Pfad ist erforderlich.",
        "Sekcja": "Abschnitt",
        "Sekcja lokalizowana": "Lokalisierter Abschnitt",
        "Sekcja modułu": "Modulabschnitt",
        "Sekcja powtarzalna": "Wiederholbarer Abschnitt",
        "Sekcja ukryta": "Ausgeblendeter Abschnitt",
        "Sekcja zostanie skonfigurowana z domyślnymi właściwościami, uprawnieniami i endpointami API.": "Der Abschnitt wird mit Standardeigenschaften, Berechtigungen und API-Endpunkten konfiguriert.",
        "Sekcje modułu": "Modulabschnitte",
        "Sekcje specyfikacji EQL": "EQL-Spezifikationsabschnitte",
        "Sekcje: %0": "Abschnitte: %0",
        "Selektor ikony": "Symbolauswahl",
        "Selektor kolorów": "Farbauswahl",
        "Server Side Cache": "Serverseitiger Cache",
        "Skala 1-5": "Skala von 1 bis 5",
        "Skopiowano": "Kopiert",
        "Skopiowano klucz": "Schlüssel kopiert",
        "Skrypt (C#)": "Skript (C#)",
        "Skrypt C#": "C#-Skript",
        "Skrypt wykonywalny": "Ausführbares Skript",
        "Słownik": "Wörterbuch",
        "Sortowanie": "Sortierung",
        "Sortuj": "Sortieren",
        "Sparametryzowane": "Parametrisiert",
        "Specjalizowane": "Spezialisiert",
        "Specyfikacja": "Spezifikation",
        "Sposób dystrybucji": "Verteilungsart",
        "Sposób prezentacji dokumentów w panelu.": "Darstellung der Dokumente im Bedienfeld.",
        "Sposób prezentacji zakładek": "Darstellung der Tabs",
        "Sposób przekazania Id encji": "Art der Übergabe der Entitäts-ID",
        "Sposób wyszukiwania": "Suchmethode",
        "Sprawdza rzeczywisty typ pliku.": "Prüft den tatsächlichen Dateityp.",
        "Sprawdzenie czy pusty": "Prüfen, ob leer",
        "Spróbuj ponownie": "Erneut versuchen",
        "Średni": "Mittel",
        "Średnia": "Durchschnitt",
        "Średnia wartość (Average)": "Durchschnittswert (Average)",
        "Stała wartość": "Fester Wert",
        "Stan": "Zustand",
        "Standardowe": "Standard",
        "Standardowe uprawnienia": "Standardberechtigungen",
        "Standardowy": "Standard",
        "Start": "Start",
        "Status": "Status",
        "Status dokumentu został zmieniony.": "Der Dokumentstatus wurde geändert.",
        "Status modułu": "Modulstatus",
        "Status publikacji": "Veröffentlichungsstatus",
        "Status webhooka": "Webhook-Status",
        "Status żądania": "Anfragestatus",
        "string": "string",
        "String": "String",
        "Strona": "Seite",
        "Strona %0": "Seite %0",
        "Strony formularza": "Formularseiten",
        "Studio": "Studio",
        "Stwierdzenie": "Aussage",
        "Styl": "Stil",
        "Sukces": "Erfolg",
        "Suma": "Summe",
        "Suma wartości (Sum)": "Summe der Werte (Sum)",
        "Sumowanie": "Summierung",
        "Switch": "Schalter",
        "Sygnatura dokumentu": "Dokumentsignatur",
        "Symbol": "Symbol",
        "Symbol endpointu": "Endpoint-Symbol",
        "Symbol jest wymagany": "Das Symbol ist erforderlich",
        "Symbol jest zajęty": "Das Symbol ist bereits vergeben",
        "Symbol modułu": "Modulsymbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "Das Symbol darf nur Kleinbuchstaben, Ziffern und das Zeichen - enthalten ",
        "Symbol musi mieć co najmniej 3 znaki": "Das Symbol muss mindestens 3 Zeichen lang sein",
        "Symbol musi mieć co najmniej 4 znaki": "Das Symbol muss mindestens 4 Zeichen lang sein",
        "Symbol nie może być dłuższy niż 10 znaków": "Das Symbol darf nicht länger als 10 Zeichen sein",
        "Symbol nie może być dłuższy niż 20 znaków": "Das Symbol darf nicht länger als 20 Zeichen sein",
        "Symbol uprawnienia": "Berechtigungssymbol",
        "Symbol w adresie URL": "Symbol in der URL",
        "Symbol: A–Z": "Symbol: A–Z",
        "Symbol: Z–A": "Symbol: Z–A",
        "Synchronizuj": "Synchronisieren",
        "System": "System",
        "Szablon email": "E-Mail-Vorlage",
        "Szablon modułu": "Modulvorlage",
        "Szablon wiadomości email": "E-Mail-Nachrichtenvorlage",
        "Szablon: A–Z": "Vorlage: A–Z",
        "Szablon: Z–A": "Vorlage: Z–A",
        "Szablony definiowane są w ": "Vorlagen werden definiert in ",
        "Szczegóły": "Details",
        "Szczegóły błędu": "Fehlerdetails",
        "Szczegóły endpointu": "Endpoint-Details",
        "Szerokość": "Breite",
        "Szerokość geograficzna": "Geografische Breite",
        "Szkic": "Entwurf",
        "Szukaj dokumentu...": "Dokument suchen...",
        "Szukaj elementu scenariusza": "Szenarioelement suchen",
        "Szukaj elementu…": "Element suchen…",
        "Szukaj kategorii…": "Kategorie suchen…",
        "Szukaj kontrolki": "Steuerelement suchen",
        "Szukaj kontrolki…": "Steuerelement suchen…",
        "Ta sekcja nie ma pola tekstowego — lista pokazuje najnowsze dokumenty.": "Dieser Abschnitt verfügt über kein Textfeld – die Liste zeigt die neuesten Dokumente.",
        "Tabela": "Tabelle",
        "Tak": "Ja",
        "Tak/Nie": "Ja/Nein",
        "Tekst": "Text",
        "Tekst lokalizowany": "Lokalisierter Text",
        "Tekst szybki": "Kurzer Text",
        "Tekst zaawansowany": "Erweiterter Text",
        "Tekst zastępczy": "Platzhaltertext",
        "Telefon": "Telefon",
        "Ten dokument edytują również:": "Dieses Dokument wird auch bearbeitet von:",
        "Teraz": "Jetzt",
        "Test": "Test",
        "Testuj": "Testen",
        "Testuj zapytanie": "Abfrage testen",
        "Timeout (sekundy)": "Timeout (Sekunden)",
        "To stały identyfikator systemowy kontrolki. Łączy ją z danymi i ustawieniami formularza, dlatego nie można go zmienić.": "Dies ist eine feste System-ID des Steuerelements. Sie verknüpft es mit den Daten und Formulareinstellungen und kann daher nicht geändert werden.",
        "To techniczny identyfikator pola używany w danych i wyrażeniach formularza. Zmiana nazwy może wymagać aktualizacji odwołań i integracji.": "Dies ist die technische ID des Feldes, die in den Daten und Ausdrücken des Formulars verwendet wird. Eine Änderung des Namens kann eine Aktualisierung von Verweisen und Integrationen erforderlich machen.",
        "Token": "Token",
        "Transformacja": "Transformation",
        "Transformacja kolekcji": "Sammlungstransformation",
        "Treść": "Inhalt",
        "Treść na przycisku dodawania dokumentu": "Text auf der Schaltfläche zum Hinzufügen eines Dokuments",
        "Treść opcji": "Optionsinhalt",
        "Treści odpowiedzi są wymagane": "Antwortinhalte sind erforderlich",
        "Treści pytań są wymagane": "Frageninhalte sind erforderlich",
        "True": "Wahr",
        "Trwa porównywanie wersji...": "Versionen werden verglichen...",
        "Tryb edytora formularza": "Formulareditormodus",
        "Tryb prezentacyjny": "Präsentationsmodus",
        "Tryb zaawansowany": "Erweiterter Modus",
        "Trzy kolumny": "Drei Spalten",
        "Tworzenie dokumentów": "Dokumenterstellung",
        "Tworzenie dokumentu": "Dokument erstellen",
        "Tworzenie encji": "Entität erstellen",
        "tydzień": "Woche",
        "Tydzień": "Woche",
        "Tylko do odczytu": "Schreibgeschützt",
        "Tylko JavaScript": "Nur JavaScript",
        "Typ agregacji": "Aggregationstyp",
        "Typ autoryzacji": "Authentifizierungstyp",
        "Typ kontentu": "Inhaltstyp",
        "Typ odbiorcy": "Empfängertyp",
        "Typ pola": "Feldtyp",
        "Typ wyniku": "Ergebnistyp",
        "Typ zmiennej": "Variablentyp",
        "TypeScript i instrukcje import nie są obsługiwane.": "TypeScript und Import-Anweisungen werden nicht unterstützt.",
        "Typy elementów listy": "Listenelementtypen",
        "Tytuł": "Titel",
        "Tytuł formularza jest wymagany": "Der Formulartitel ist erforderlich",
        "Tytuł formularza nie może być dłuższy niż %0 znaków": "Der Formulartitel darf nicht länger als %0 Zeichen sein",
        "Tytuł sekcji": "Abschnittstitel",
        "Udostępnia sekcję w aranżacjach.": "Stellt den Abschnitt in Layouts zur Verfügung.",
        "Układ": "Layout",
        "Ukryj": "Ausblenden",
        "Ukryj filtr w domyślnym widoku.": "Filter in der Standardansicht ausblenden.",
        "Ukryj kolumnę w domyślnym widoku.": "Spalte in der Standardansicht ausblenden.",
        "Ukryta": "Ausgeblendet",
        "Ukryty": "Ausgeblendet",
        "Ukrywa moduł w menu nawigacyjnym.": "Blendet das Modul im Navigationsmenü aus.",
        "Ukrywa sekcję w menu tego modułu.": "Blendet den Abschnitt im Menü dieses Moduls aus.",
        "Ulica": "Straße",
        "Umożliwia korzystanie z modułu w panelu.": "Ermöglicht die Nutzung des Moduls im Dashboard.",
        "Unikalna wartość": "Eindeutiger Wert",
        "Uprawnienia": "Berechtigungen",
        "Uprawnienia do dokumentów": "Berechtigungen für Dokumente",
        "Uprawnienia rozróżniają operacje na własnych, wszystkich i wskazanych dokumentach.": "Die Berechtigungen unterscheiden zwischen Vorgängen für eigene, alle und ausgewählte Dokumente.",
        "Url": "URL",
        "Uruchom proces": "Prozess starten",
        "Uruchomienie harmonogramu": "Zeitplan starten",
        "Uruchomienie podprocesu": "Unterprozess starten",
        "Uruchomienie procesu": "Prozess starten",
        "Ustaw szerokości proporcjonalnie": "Breiten proportional festlegen",
        "Ustawienia": "Einstellungen",
        "Ustawienia formularza": "Formulareinstellungen",
        "Ustawienia kolumny": "Spalteneinstellungen",
        "Ustawienia scenariusza": "Szenarioeinstellungen",
        "Ustawienia sekcji": "Abschnittseinstellungen",
        "Ustawienia webhooka": "Webhook-Einstellungen",
        "Ustawienia zostały zapisane.": "Die Einstellungen wurden gespeichert.",
        "Usuń": "Löschen",
        "Usuń dokument": "Dokument löschen",
        "Usuń grupę": "Gruppe löschen",
        "Usuń kolumnę": "Spalte löschen",
        "Usuń logi gdy wykonywanie scenariusza": "Protokolle bei der Ausführung des Szenarios löschen",
        "Usuń opcję": "Option löschen",
        "Usuń parametr": "Parameter löschen",
        "Usuń pole": "Feld löschen",
        "Usuń pozycję": "Eintrag löschen",
        "Usuń punkt": "Punkt löschen",
        "Usuń pytanie": "Frage löschen",
        "Usuń sekcję": "Abschnitt löschen",
        "Usuń spacje": "Leerzeichen entfernen",
        "Usuń warunek": "Bedingung löschen",
        "Usuń wydarzenie": "Ereignis löschen",
        "Usuń z dokumentami": "Mit Dokumenten löschen",
        "Usunąć grupę uprawnień?": "Berechtigungsgruppe löschen?",
        "Usunąć tę sekcję z modułu?": "Diesen Abschnitt aus dem Modul entfernen?",
        "Usunąć uprawnienie?": "Berechtigung löschen?",
        "Usunięcie dokumentu": "Dokument löschen",
        "Usunięcie formularza\n\nOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!\nCzy na pewno chcesz usunąć wybrany formularz?": "Formular löschen\n\nDieser Vorgang kann nicht rückgängig gemacht werden. Alle zugehörigen Dokumente gehen verloren!\nMöchten Sie das ausgewählte Formular wirklich löschen?",
        "Usunięcie wpisu": "Eintrag löschen",
        "Usunięte": "Gelöscht",
        "Usunięto formularze": "Formulare gelöscht",
        "Usunięto kategorii: {count}.": "Kategorien gelöscht: {count}.",
        "Usunięto scenariusze: {count}.": "Szenarien gelöscht: {count}.",
        "Usuwanie dokumentów": "Dokumente löschen",
        "Usuwanie duplikatów": "Duplikate löschen",
        "Usuwanie encji": "Entitäten löschen",
        "Usuwanie własnych dokumentów": "Eigene Dokumente löschen",
        "Usuwanie wszystkich dokumentów": "Alle Dokumente löschen",
        "Utwórz formularz": "Formular erstellen",
        "Utwórz kopię formularza": "Formularkopie erstellen",
        "Utwórz kopię z": "Kopie erstellen aus",
        "Utwórz scenariusz": "Szenario erstellen",
        "Utworzenie wpisu": "Eintrag erstellen",
        "Użycie w aranżacjach": "Verwendung in Layouts",
        "Użyj domyślnego zapytania SQL": "Standard-SQL-Abfrage verwenden",
        "Użytkownik": "Benutzer",
        "W przyszłości": "In Zukunft",
        "W widgetu zmiennej możliwe jest zdefiniowanie wartości dla jednego z podstawowych typów danych, do wykorzystania w dalszej części procesu.": "Im Variablen-Widget können Sie einen Wert für einen der grundlegenden Datentypen definieren, der im weiteren Prozessverlauf verwendet werden kann.",
        "w wyznaczonym zakresie": "im festgelegten Bereich",
        "W zapytaniu EQL można używać zmiennych, np.": "In der EQL-Abfrage können Variablen verwendet werden, z. B.",
        "W zapytaniu można używać nazw zmiennych z parametrów wejściowych skryptu, np.:": "In der Abfrage können Variablennamen aus den Eingabeparametern des Skripts verwendet werden, z. B.:",
        "Walidacja": "Validierung",
        "Walidacja danych": "Datenvalidierung",
        "Walidacja po stronie API": "Validierung auf API-Seite",
        "Walidacja typów MIME": "MIME-Typ-Validierung",
        "Walidacja typu": "Typvalidierung",
        "Wariant powiadomienia": "Benachrichtigungsvariante",
        "Wartość": "Wert",
        "Wartość domyślna": "Standardwert",
        "Wartość jest zbyt długa.": "Der Wert ist zu lang.",
        "Wartość lub wyrażenie": "Wert oder Ausdruck",
        "Wartość lub wyrażenie C#": "C#-Wert oder -Ausdruck",
        "Wartość opcji": "Optionswert",
        "Wartość parametru musi pasować do jego użycia w zapytaniu. Może to być": "Der Parameterwert muss mit seiner Verwendung in der Abfrage übereinstimmen. Es kann sich um Folgendes handeln:",
        "Wartość pola": "Feldwert",
        "Wartośc pola jest wymagana": "Der Feldwert ist erforderlich",
        "Wartość warunku jest wymagana": "Der Bedingungswert ist erforderlich",
        "Wartość zmiennej": "Variablenwert",
        "Wartości zmiennych pochodzą z parametrów GET. Zmiennej": "Die Variablenwerte stammen aus GET-Parametern. Die Variable",
        "Warunek": "Bedingung",
        "Warunek i mapowanie": "Bedingung und Zuordnung",
        "Warunek jest zdefiniowany przy użyciu wyrażenia lambda w C#. Przykład:": "Die Bedingung wird mithilfe eines Lambda-Ausdrucks in C# definiert. Beispiel:",
        "Warunek łączenia uprawnień": "Bedingung für die Verknüpfung von Berechtigungen",
        "Warunek nie zostanie spełniony": "Die Bedingung wird nicht erfüllt",
        "Warunek oraz mapowanie używają składni Dynamic LINQ. Przy mapowaniu możesz nadać polu nową nazwę przez as, np. Category.Name as CategoryName.": "Bedingung und Zuordnung verwenden die Dynamic-LINQ-Syntax. Bei der Zuordnung können Sie einem Feld mit „as“ einen neuen Namen zuweisen, z. B. Category.Name as CategoryName.",
        "Warunek tylko do odczytu": "Schreibgeschützte Bedingung",
        "Warunek widoczności": "Sichtbarkeitsbedingung",
        "Warunek wymagania": "Erforderlichkeitsbedingung",
        "Warunek zostanie spełniony": "Die Bedingung wird erfüllt",
        "Warunki": "Bedingungen",
        "Warunki logiczne": "Logische Bedingungen",
        "Warunkowo": "Bedingt",
        "Ważność": "Gültigkeit",
        "Wbudowany skrypt C#": "Integriertes C#-Skript",
        "Wczytaj opublikowaną definicję formularza.": "Laden Sie die veröffentlichte Formulardefinition.",
        "Wczytywanie definicji formularza": "Formulardefinition wird geladen",
        "Wczytywanie formularza…": "Formular wird geladen…",
        "Wczytywanie komponentów": "Komponenten werden geladen",
        "Wczytywanie konfiguracji endpointu": "Endpoint-Konfiguration wird geladen",
        "Wczytywanie kontrolek formularza…": "Formularsteuerelemente werden geladen…",
        "Wczytywanie modelu danych": "Datenmodell wird geladen",
        "Wczytywanie modułów": "Module werden geladen",
        "Wczytywanie modułu": "Modul wird geladen",
        "Wczytywanie modułu…": "Modul wird geladen…",
        "Wczytywanie operacji": "Vorgänge werden geladen",
        "Wczytywanie operacji formularza": "Formularvorgänge werden geladen",
        "Wczytywanie podglądu szablonu…": "Vorlagenvorschau wird geladen…",
        "Wczytywanie pól formularza": "Formularfelder werden geladen",
        "Wczytywanie powtórzeń": "Wiederholungen werden geladen",
        "Wczytywanie procesu": "Prozess wird geladen",
        "Wczytywanie scenariusza": "Szenario wird geladen",
        "Wczytywanie wersji...": "Versionen werden geladen...",
        "Wczytywanie właściwości i podglądu szablonu…": "Eigenschaften und Vorlagenvorschau werden geladen…",
        "Webhook": "Webhook",
        "Webhook zapisano, ale nie udało się go zaakceptować.": "Der Webhook wurde gespeichert, konnte aber nicht freigegeben werden.",
        "Webhook został dodany.": "Der Webhook wurde hinzugefügt.",
        "Webhook został usunięty.": "Der Webhook wurde gelöscht.",
        "Webhook został zaktualizowany.": "Der Webhook wurde aktualisiert.",
        "Webhooki": "Webhooks",
        "Wersja bazowa": "Basisversion",
        "Wersja formularza": "Formularversion",
        "Wersja porównywana": "Verglichene Version",
        "Wersja zaakceptowana": "Freigegebene Version",
        "Wersje": "Versionen",
        "Wersje i uprawnienia": "Versionen und Berechtigungen",
        "Wersjonowany": "Versioniert",
        "Wewnętrznie": "Intern",
        "Widget służy do budowania obiektu z wybranych wartości.": "Das Widget dient dazu, aus ausgewählten Werten ein Objekt zu erstellen.",
        "Widget służy do parsowania szablonów w języku Liquid.": "Das Widget dient zum Parsen von Vorlagen in der Liquid-Sprache.",
        "Widget służy do renderowania MJML na HTML": "Das Widget dient dazu, MJML in HTML zu rendern.",
        "Widget umożliwia uruchomienie dowolnego wbudowanego skryptu C#.": "Mit dem Widget kann ein beliebiges integriertes C#-Skript ausgeführt werden.",
        "Widget wybiera model z globalnej konfiguracji AI zgodnie z typem wyniku. Nie wybiera konkretnego modelu.": "Das Widget wählt entsprechend dem Ergebnistyp ein Modell aus der globalen KI-Konfiguration aus. Es wählt kein bestimmtes Modell aus.",
        "Widget wyzwala scenariusz po wykonaniu akcji wybranej w polu": "Das Widget löst ein Szenario aus, nachdem die im Feld ausgewählte Aktion ausgeführt wurde.",
        "Widget zwraca prawdę, gdy wejściowa wartość ma przynajmniej jeden zaznaczony typ. Dla listy możesz dodatkowo ograniczyć typ każdego jej elementu.": "Das Widget gibt „Wahr“ zurück, wenn der Eingabewert mindestens einen ausgewählten Typ aufweist. Bei einer Liste können Sie zusätzlich den Typ jedes Elements einschränken.",
        "Widget zwracana wybrany szablon wiadomości email.": "Das Widget gibt die ausgewählte E-Mail-Vorlage zurück.",
        "Widoczność": "Sichtbarkeit",
        "Widoczność sekcji w menu modułu": "Sichtbarkeit des Abschnitts im Modulmenü",
        "Widoczność w menu": "Sichtbarkeit im Menü",
        "Widok diagramu": "Diagrammansicht",
        "Widok kalendarza": "Kalenderansicht",
        "Więcej...": "Mehr...",
        "Większe lub równe": "Größer oder gleich",
        "Większe niż": "Größer als",
        "Wielkość kroku": "Schrittgröße",
        "Wielokrotny": "Mehrfach",
        "Wiersz": "Zeile",
        "Wiersz %0": "Zeile %0",
        "Wiersze do importu:": "Zu importierende Zeilen:",
        "Wklej komponent": "Komponente einfügen",
        "Włącz": "Aktivieren",
        "Włącz konfigurację zaawansowaną, aby zdefiniować własne zapytanie EQL i przetestować jego wynik.": "Aktivieren Sie die erweiterte Konfiguration, um eine eigene EQL-Abfrage zu definieren und ihr Ergebnis zu testen.",
        "Włącz walidację po stronie API": "Validierung auf API-Seite aktivieren",
        "Włącza przyjmowanie żądań przez webhook.": "Aktiviert die Annahme von Anfragen durch den Webhook.",
        "Włączone": "Aktiviert",
        "Właściwości": "Eigenschaften",
        "Właściwości komponentu": "Komponenteneigenschaften",
        "Właściwości szablonu": "Vorlageneigenschaften",
        "Właściwości wpisu": "Eintragseigenschaften",
        "Województwo": "Woiwodschaft",
        "Wpis został dodany.": "Der Eintrag wurde hinzugefügt.",
        "Wpis został usunięty": "Der Eintrag wurde gelöscht",
        "Wpis został zaakceptowany.": "Der Eintrag wurde freigegeben.",
        "Wpis został zaktualizowany.": "Der Eintrag wurde aktualisiert.",
        "Wpisz ciało funkcji walidującej dane w JavaScript.": "Geben Sie den Funktionskörper für die Datenvalidierung in JavaScript ein.",
        "Wpisz co najmniej 4 znaki.": "Geben Sie mindestens 4 Zeichen ein.",
        "Wróć do diagramu": "Zurück zum Diagramm",
        "Wskaż formularz, którego pola mają pojawić się w edytorze konta. Zmiana dotyczy wszystkich kont - wcześniej wprowadzone wartości pozostają zapisane.": "Wählen Sie das Formular aus, dessen Felder im Konteneditor angezeigt werden sollen. Die Änderung betrifft alle Konten – zuvor eingegebene Werte bleiben gespeichert.",
        "Wskaż moduł, sekcję i metodę, aby zobaczyć adres oraz konfigurację.": "Wählen Sie ein Modul, einen Abschnitt und eine Methode aus, um die Adresse und Konfiguration anzuzeigen.",
        "Wskaż pole liczbowe, na którym ma zostać obliczona wybrana operacja.": "Wählen Sie ein Zahlenfeld aus, auf das die ausgewählte Operation angewendet werden soll.",
        "Wskazuje, jak długo odpowiedź pozostaje aktualna w pamięci serwera Redis.": "Legt fest, wie lange die Antwort im Redis-Serverspeicher aktuell bleibt.",
        "Wstaw kontrolkę": "Steuerelement einfügen",
        "Wstaw stronę": "Seite einfügen",
        "Wstaw z dołu": "Von unten einfügen",
        "Wstaw z góry": "Von oben einfügen",
        "Wstaw z lewej strony": "Von links einfügen",
        "Wstaw z prawej strony": "Von rechts einfügen",
        "Wstecz": "Zurück",
        "Wszystkie": "Alle",
        "Wybierz": "Auswählen",
        "Wybierz co najmniej jeden typ wartości.": "Wählen Sie mindestens einen Werttyp aus.",
        "Wybierz dokumenty": "Dokumente auswählen",
        "Wybierz dostępny szablon modułu.": "Wählen Sie eine verfügbare Modulvorlage aus.",
        "Wybierz endpoint": "Endpunkt auswählen",
        "Wybierz formularz": "Formular auswählen",
        "Wybierz formularz, aby zobaczyć jego pola.": "Wählen Sie ein Formular aus, um dessen Felder anzuzeigen.",
        "Wybierz kategorię": "Kategorie auswählen",
        "Wybierz kontrolkę lub miejsce jej wstawienia.": "Wählen Sie ein Steuerelement oder die Stelle aus, an der es eingefügt werden soll.",
        "Wybierz model docelowy, gdy zmapowany wynik ma być traktowany jako jego rekord.": "Wählen Sie das Zielmodell aus, wenn das zugeordnete Ergebnis als dessen Datensatz behandelt werden soll.",
        "Wybierz model, dodaj warunek tylko dla potrzebnych rekordów i dobierz operację do oczekiwanego wyniku.": "Wählen Sie ein Modell aus, fügen Sie eine Bedingung hinzu, um nur die benötigten Datensätze zu berücksichtigen, und wählen Sie die passende Operation für das gewünschte Ergebnis.",
        "Wybierz moduł": "Modul auswählen",
        "Wybierz moduł z menu po lewej stronie, aby edytować jego zawartość.": "Wählen Sie im Menü auf der linken Seite ein Modul aus, um dessen Inhalt zu bearbeiten.",
        "Wybierz moduł, aby dodać sekcję – lub zostaw puste, aby utworzyć nowy moduł": "Wählen Sie ein Modul aus, um einen Abschnitt hinzuzufügen – oder lassen Sie das Feld leer, um ein neues Modul zu erstellen",
        "wybierz moduł...": "Modul auswählen...",
        "Wybierz operację, aby zobaczyć wynik i szczegóły.": "Wählen Sie eine Operation aus, um das Ergebnis und die Details anzuzeigen.",
        "Wybierz plik CSV": "CSV-Datei auswählen",
        "Wybierz sekcję": "Abschnitt auswählen",
        "wybierz sekcję...": "Abschnitt auswählen...",
        "Wybierz typ wartości.": "Wählen Sie einen Werttyp aus.",
        "Wybierz typ wyniku.": "Wählen Sie einen Ergebnistyp aus.",
        "wybierz...": "Auswählen...",
        "Wybierz…": "Auswählen…",
        "Wybór": "Auswahl",
        "Wybór formularza": "Formularauswahl",
        "Wybór języka": "Sprachauswahl",
        "Wybór operacji jest wymagany.": "Die Auswahl einer Operation ist erforderlich.",
        "Wybór wpływa na kolor szablonu.": "Die Auswahl beeinflusst die Farbe der Vorlage.",
        "Wybór wpływa tylko na treść stopki.": "Die Auswahl beeinflusst nur den Inhalt der Fußzeile.",
        "Wybór+": "Auswahl+",
        "Wybrana data jest mniejsza niż dozwolona %0.": "Das ausgewählte Datum liegt vor dem zulässigen Datum %0.",
        "Wybrana data jest większa niż dozwolona %0.": "Das ausgewählte Datum liegt nach dem zulässigen Datum %0.",
        "Wybrana godzina jest późniejsza niż dozwolona %0.": "Die ausgewählte Uhrzeit liegt nach der zulässigen Uhrzeit %0.",
        "Wybrana godzina jest wcześniejsza niż dozwolona %0.": "Die ausgewählte Uhrzeit liegt vor der zulässigen Uhrzeit %0.",
        "Wybrana liczba jest mniejsza niż dozwolona %0.": "Die ausgewählte Zahl ist kleiner als der zulässige Wert %0.",
        "Wybrana liczba jest większa niż dozwolona %0.": "Die ausgewählte Zahl ist größer als der zulässige Wert %0.",
        "Wybrana wersja": "Ausgewählte Version",
        "Wybrane": "Ausgewählt",
        "Wybrane dokumenty": "Ausgewählte Dokumente",
        "Wybrane: %0": "Ausgewählt: %0",
        "Wybranie przynajmniej jednego pola do aktualizacji jest wymagane.": "Es muss mindestens ein Feld für die Aktualisierung ausgewählt werden.",
        "Wybranie przynajmniej jednego warunku jest wymagane.": "Es muss mindestens eine Bedingung ausgewählt werden.",
        "Wybrany formularz nie zawiera pól.": "Das ausgewählte Formular enthält keine Felder.",
        "Wybrany użytkownik": "Ausgewählter Benutzer",
        "Wyczyść": "Leeren",
        "Wyczyść wartość": "Wert leeren",
        "Wyczyść wybór": "Auswahl aufheben",
        "Wyczyść wyszukiwanie": "Suche löschen",
        "Wyczyścić uprawnienia sekcji?": "Berechtigungen für den Abschnitt löschen?",
        "Wydarzenie zostało zduplikowane.": "Das Ereignis wurde dupliziert.",
        "Wygląd formularza z wybranymi ustawieniami.": "Darstellung des Formulars mit den ausgewählten Einstellungen.",
        "Wygląd modułu i formularza po konfiguracji.": "Darstellung des Moduls und des Formulars nach der Konfiguration.",
        "Wykonuje się": "Wird ausgeführt",
        "Wykryto kolumny:": "Erkannte Spalten:",
        "Wyłączone": "Deaktiviert",
        "Wyłuskaj dane do wybranej właściwości poprzez wyrażenie w formacie języka C#. Albo zostaw pole puste, wtedy zostanie zwrócony cały wynik.": "Extrahieren Sie die Daten über einen Ausdruck im C#-Format in die ausgewählte Eigenschaft. Lassen Sie das Feld leer, um das gesamte Ergebnis zurückzugeben.",
        "Wymaga autoryzacji": "Autorisierung erforderlich",
        "Wymagana konfiguracja": "Konfiguration erforderlich",
        "Wymagane": "Erforderlich",
        "Wymagane jest wybranie formularza": "Ein Formular muss ausgewählt werden",
        "Wymagane jest wybranie kategorii": "Eine Kategorie muss ausgewählt werden",
        "Wymagane jest wybranie komponentu": "Eine Komponente muss ausgewählt werden",
        "Wymagane jest wybranie modułu": "Ein Modul muss ausgewählt werden",
        "Wymagane jest wybranie sekcji": "Ein Abschnitt muss ausgewählt werden",
        "Wymagane jest wybranie źródła": "Eine Quelle muss ausgewählt werden",
        "Wymagane jest wybranie źródła danych": "Eine Datenquelle muss ausgewählt werden",
        "Wymagane znaki": "Erforderliche Zeichen",
        "Wymień wpis": "Eintrag ersetzen",
        "Wynik etapu (JSON)": "Ergebnis des Schritts (JSON)",
        "Wynik etapu jest wymagany": "Das Ergebnis des Schritts ist erforderlich",
        "Wynik operacji": "Operationsergebnis",
        "Wynik testu": "Testergebnis",
        "Wynik transformacji": "Transformationsergebnis",
        "Wynik walidacji": "Validierungsergebnis",
        "Wyrażenia warunkowe": "Bedingte Ausdrücke",
        "Wyrażenie EQL": "EQL-Ausdruck",
        "Wyrażenie jest prawidłowe. Udało się pobrać wartość z wyniku.": "Der Ausdruck ist gültig. Der Wert konnte aus dem Ergebnis abgerufen werden.",
        "Wyrażenie nie jest prawidłowe. Nie udało się pobrać wartości z wyniku.": "Der Ausdruck ist ungültig. Der Wert konnte nicht aus dem Ergebnis abgerufen werden.",
        "Wyrażenie regularne": "Regulärer Ausdruck",
        "Wyrażenie w postaci \"/pattern/flag\" nie jest obsługiwane, użyj same wartości pattern": "Ausdrücke im Format \"/pattern/flag\" werden nicht unterstützt. Verwenden Sie nur den Wert pattern",
        "Wysłanie emaila": "E-Mail senden",
        "Wysłanie powiadomień": "Benachrichtigungen senden",
        "Wyślij": "Senden",
        "Wyślij powiadomienie gdy wykonywanie scenariusza": "Benachrichtigung senden, wenn das Szenario ausgeführt wird",
        "Wysoka": "Hoch",
        "Wystąpił błąd podczas otwierania modułu. Możesz spróbować ponownie lub wrócić do listy modułów.": "Beim Öffnen des Moduls ist ein Fehler aufgetreten. Sie können es erneut versuchen oder zur Modulliste zurückkehren.",
        "Wystąpił błąd podczas próby importu definicji modułu.": "Beim Importieren der Moduldefinition ist ein Fehler aufgetreten.",
        "Wystąpił nieokreślony problem.": "Ein unbekanntes Problem ist aufgetreten.",
        "Wyświetlanie dokumentów": "Dokumente anzeigen",
        "Wyszukaj encję…": "Entität suchen…",
        "Wyszukiwany ciąg znaków": "Suchbegriff",
        "Wytnij": "Ausschneiden",
        "Wywołanie powiadomienia": "Benachrichtigung auslösen",
        "Wywołanie webhooka": "Webhook auslösen",
        "Wywołanie zdarzenia": "Ereignis auslösen",
        "Wyzwalacze": "Trigger",
        "Wzorzec": "Vorlage",
        "Z uprawnieniami do modułu": "Mit Berechtigungen für das Modul",
        "Zaakceptowany": "Akzeptiert",
        "Zaawansowane": "Erweitert",
        "Zaawansowane uprawnienia": "Erweiterte Berechtigungen",
        "Zaawansowany edytor tekstu": "Erweiterter Texteditor",
        "Zablokuj edycję diagramu": "Bearbeiten des Diagramms sperren",
        "Zachowaj oryginalny format obrazów": "Originalformat der Bilder beibehalten",
        "zacznij pisać aby wyszukać szablon...": "Beginnen Sie mit der Eingabe, um eine Vorlage zu suchen ...",
        "zacznij pisać aby wyszukać użytkownika...": "Beginnen Sie mit der Eingabe, um einen Benutzer zu suchen ...",
        "Zacznij pisać Form lub Entry aby uruchomić podpowiadanie.": "Beginnen Sie mit der Eingabe von Form oder Entry, um die Vorschläge zu aktivieren.",
        "Zaczyna sie od": "Beginnt mit",
        "Zagrożenie": "Bedrohung",
        "Zaimportowano definicję modułu.": "Die Moduldefinition wurde importiert.",
        "Zakładki": "Registerkarten",
        "Zakończ edycje": "Bearbeitung beenden",
        "Zakończony": "Abgeschlossen",
        "zakończy się porażką": "schlägt fehl",
        "zakończy się sukcesem": "ist erfolgreich",
        "Zakres": "Bereich",
        "Zakres czasu": "Zeitraum",
        "Zakres funkcjonalności": "Funktionsumfang",
        "Zakres uprawnienia": "Berechtigungsumfang",
        "Zaktualizuj formularz": "Formular aktualisieren",
        "Zaktualizuj najnowszą wersję dokumentu": "Neueste Dokumentversion aktualisieren",
        "Załączniki": "Anhänge",
        "Zależna od kontrolki": "Abhängig von der Steuerung",
        "Zamień wersje": "Versionen austauschen",
        "Zamknij": "Schließen",
        "Zaokrąglenie": "Rundung",
        "Zapisz": "Speichern",
        "Zapisz i wróć": "Speichern und zurück",
        "Zapisz i zamknij": "Speichern und schließen",
        "Zapisz jako": "Speichern unter",
        "Zapisz kategorię": "Kategorie speichern",
        "Zapisz pozycje": "Positionen speichern",
        "Zapisz zmiany": "Änderungen speichern",
        "Zapytania i mapowanie kolumn": "Abfragen und Spaltenzuordnung",
        "Zapytanie": "Abfrage",
        "Zapytanie do bazy danych": "Datenbankabfrage",
        "Zapytanie HTTP": "HTTP-Anfrage",
        "Zapytanie SQL do pobrania po ID": "SQL-Abfrage zum Abrufen nach ID",
        "Zapytanie SQL do wyszukiwania": "SQL-Suchabfrage",
        "Zasięg": "Reichweite",
        "Zawiera": "Enthält",
        "Zawiera nagłówki": "Enthält Header",
        "Zawiera parametry query": "Enthält Query-Parameter",
        "Zawiera treść": "Enthält Inhalt",
        "Zawsze": "Immer",
        "Zdecyduj czy scenariusz ma obsługiwać wczystkie czy tylko wybrane powiadomienia.": "Legen Sie fest, ob das Szenario alle oder nur ausgewählte Benachrichtigungen verarbeiten soll.",
        "Zdecyduj czy scenariusz ma obsługiwać wszystkie czy tylko wybrane kanały.": "Legen Sie fest, ob das Szenario alle oder nur ausgewählte Kanäle verarbeiten soll.",
        "Zdefiniuj wygląd komponentu oraz opcjonalne reguły sprawdzania danych po stronie API.": "Definieren Sie das Aussehen der Komponente und optional die Regeln zur Datenvalidierung auf API-Seite.",
        "Zdjęcia": "Bilder",
        "Zdjęcie": "Bild",
        "Zestaw uprawnień": "Berechtigungssatz",
        "Zgoda": "Einwilligung",
        "Zliczanie": "Zählen",
        "Zmiana statusu jest teraz niedostępna.": "Die Statusänderung ist derzeit nicht verfügbar.",
        "Zmiany": "Änderungen",
        "Zmiany zostały zapisane.": "Die Änderungen wurden gespeichert.",
        "Zmienione": "Geändert",
        "Zmienna": "Variable",
        "Zmienna musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "Die Variable muss mit einem Kleinbuchstaben beginnen und darf nur alphanumerische Zeichen enthalten",
        "Zmienne w zapytaniu EQL": "Variablen in der EQL-Abfrage",
        "Zmniejsz": "Verkleinern",
        "Znaczenie operacji": "Bedeutung des Vorgangs",
        "Znaki specialne": "Sonderzeichen",
        "Zoom": "Zoom",
        "Zostaną zaktualizowane definicje wszystkich dokumentów.": "Die Definitionen aller Dokumente werden aktualisiert.",
        "Źródła danych": "Datenquellen",
        "Źródło danych": "Datenquelle",
        "Żródło danych": "Datenquelle",
        "Źródło danych zostało dodane.": "Die Datenquelle wurde hinzugefügt.",
        "Źródło danych zostało zaktualizowane.": "Die Datenquelle wurde aktualisiert.",
        "Źródło zostało usunięte.": "Die Quelle wurde gelöscht.",
        "Zwrócony": "Zurückgegeben"
    }
};
